/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

export const stateList = [
    {
        "iso": "AR",
        "value": "0",
        "label": "Capital Federal"
    },
    {
        "iso": "AR",
        "value": "1",
        "label": "Buenos Aires"
    },
    {
        "iso": "AR",
        "value": "2",
        "label": "Catamarca"
    },
    {
        "iso": "AR",
        "value": "3",
        "label": "Cordoba"
    },
    {
        "iso": "AR",
        "value": "4",
        "label": "Corrientes"
    },
    {
        "iso": "AR",
        "value": "5",
        "label": "Entre Rios"
    },
    {
        "iso": "AR",
        "value": "6",
        "label": "Jujuy"
    },
    {
        "iso": "AR",
        "value": "7",
        "label": "Mendoza"
    },
    {
        "iso": "AR",
        "value": "8",
        "label": "La Rioja"
    },
    {
        "iso": "AR",
        "value": "9",
        "label": "Salta"
    },
    {
        "iso": "AR",
        "value": "10",
        "label": "San Juan"
    },
    {
        "iso": "AR",
        "value": "11",
        "label": "San Luis"
    },
    {
        "iso": "AR",
        "value": "12",
        "label": "Santa Fe"
    },
    {
        "iso": "AR",
        "value": "13",
        "label": "Santiago del Estero"
    },
    {
        "iso": "AR",
        "value": "14",
        "label": "Tucuman"
    },
    {
        "iso": "AR",
        "value": "16",
        "label": "Chaco"
    },
    {
        "iso": "AR",
        "value": "17",
        "label": "Chubut"
    },
    {
        "iso": "AR",
        "value": "18",
        "label": "Formosa"
    },
    {
        "iso": "AR",
        "value": "19",
        "label": "Misiones"
    },
    {
        "iso": "AR",
        "value": "20",
        "label": "Neuquen"
    },
    {
        "iso": "AR",
        "value": "21",
        "label": "La Pampa"
    },
    {
        "iso": "AR",
        "value": "22",
        "label": "Rio Negro"
    },
    {
        "iso": "AR",
        "value": "23",
        "label": "Santa Cruz"
    },
    {
        "iso": "AR",
        "value": "24",
        "label": "Tierra de Fuego"
    },
    {
        "iso": "AT",
        "value": "B",
        "label": "Burgenland"
    },
    {
        "iso": "AT",
        "value": "K",
        "label": "Carinthia"
    },
    {
        "iso": "AT",
        "value": "NOE",
        "label": "Lower Austria"
    },
    {
        "iso": "AT",
        "value": "OOE",
        "label": "Upper Austria"
    },
    {
        "iso": "AT",
        "value": "S",
        "label": "Salzburg"
    },
    {
        "iso": "AT",
        "value": "ST",
        "label": "Styria"
    },
    {
        "iso": "AT",
        "value": "T",
        "label": "Tyrol"
    },
    {
        "iso": "AT",
        "value": "V",
        "label": "Vorarlberg"
    },
    {
        "iso": "AT",
        "value": "W",
        "label": "Vienna"
    },
    {
        "iso": "AU",
        "value": "ACT",
        "label": "Aust Capital Terr"
    },
    {
        "iso": "AU",
        "value": "NSW",
        "label": "New South Wales"
    },
    {
        "iso": "AU",
        "value": "NT",
        "label": "Northern Territory"
    },
    {
        "iso": "AU",
        "value": "QLD",
        "label": "Queensland"
    },
    {
        "iso": "AU",
        "value": "SA",
        "label": "South Australia"
    },
    {
        "iso": "AU",
        "value": "TAS",
        "label": "Tasmania"
    },
    {
        "iso": "AU",
        "value": "VIC",
        "label": "Victoria"
    },
    {
        "iso": "AU",
        "value": "WA",
        "label": "Western Australia"
    },
    {
        "iso": "BE",
        "value": "1",
        "label": "Antwerpen"
    },
    {
        "iso": "BE",
        "value": "2",
        "label": "Vlaams-Brabant"
    },
    {
        "iso": "BE",
        "value": "3",
        "label": "Hainaut"
    },
    {
        "iso": "BE",
        "value": "4",
        "label": "Liège"
    },
    {
        "iso": "BE",
        "value": "5",
        "label": "Limburg"
    },
    {
        "iso": "BE",
        "value": "6",
        "label": "Luxembourg"
    },
    {
        "iso": "BE",
        "value": "7",
        "label": "Namur"
    },
    {
        "iso": "BE",
        "value": "8",
        "label": "Oost-Vlaanderen"
    },
    {
        "iso": "BE",
        "value": "9",
        "label": "West-Vlaanderen"
    },
    {
        "iso": "BE",
        "value": "10",
        "label": "Walloon Brabant"
    },
    {
        "iso": "BE",
        "value": "11",
        "label": "Brussels Hoofdstedelijk Gewest"
    },
    {
        "iso": "BG",
        "value": "1",
        "label": "Burgas"
    },
    {
        "iso": "BG",
        "value": "2",
        "label": "Grad Sofiya"
    },
    {
        "iso": "BG",
        "value": "3",
        "label": "Khaskovo"
    },
    {
        "iso": "BG",
        "value": "4",
        "label": "Lovech"
    },
    {
        "iso": "BG",
        "value": "5",
        "label": "Montana"
    },
    {
        "iso": "BG",
        "value": "6",
        "label": "Plovdiv"
    },
    {
        "iso": "BG",
        "value": "7",
        "label": "Ruse"
    },
    {
        "iso": "BG",
        "value": "8",
        "label": "Sofiya"
    },
    {
        "iso": "BG",
        "value": "9",
        "label": "Varna"
    },
    {
        "iso": "BQ",
        "value": "BO",
        "label": "Bonaire"
    },
    {
        "iso": "BR",
        "value": "AC",
        "label": "Acre"
    },
    {
        "iso": "BR",
        "value": "AL",
        "label": "Alagoas"
    },
    {
        "iso": "BR",
        "value": "AM",
        "label": "Amazon"
    },
    {
        "iso": "BR",
        "value": "AP",
        "label": "Amapa"
    },
    {
        "iso": "BR",
        "value": "BA",
        "label": "Bahia"
    },
    {
        "iso": "BR",
        "value": "CE",
        "label": "Ceara"
    },
    {
        "iso": "BR",
        "value": "DF",
        "label": "Brasilia"
    },
    {
        "iso": "BR",
        "value": "ES",
        "label": "Espirito Santo"
    },
    {
        "iso": "BR",
        "value": "GO",
        "label": "Goias"
    },
    {
        "iso": "BR",
        "value": "MA",
        "label": "Maranhao"
    },
    {
        "iso": "BR",
        "value": "MG",
        "label": "Minas Gerais"
    },
    {
        "iso": "BR",
        "value": "MS",
        "label": "Mato Grosso do Sul"
    },
    {
        "iso": "BR",
        "value": "MT",
        "label": "Mato Grosso"
    },
    {
        "iso": "BR",
        "value": "PA",
        "label": "Para"
    },
    {
        "iso": "BR",
        "value": "PB",
        "label": "Paraiba"
    },
    {
        "iso": "BR",
        "value": "PE",
        "label": "Pernambuco"
    },
    {
        "iso": "BR",
        "value": "PI",
        "label": "Piaui"
    },
    {
        "iso": "BR",
        "value": "PR",
        "label": "Parana"
    },
    {
        "iso": "BR",
        "value": "RJ",
        "label": "Rio de Janeiro"
    },
    {
        "iso": "BR",
        "value": "RN",
        "label": "Rio Grande do Norte"
    },
    {
        "iso": "BR",
        "value": "RO",
        "label": "Rondonia"
    },
    {
        "iso": "BR",
        "value": "RR",
        "label": "Roraima"
    },
    {
        "iso": "BR",
        "value": "RS",
        "label": "Rio Grande do Sul"
    },
    {
        "iso": "BR",
        "value": "SC",
        "label": "Santa Catarina"
    },
    {
        "iso": "BR",
        "value": "SE",
        "label": "Sergipe"
    },
    {
        "iso": "BR",
        "value": "SP",
        "label": "Sao Paulo"
    },
    {
        "iso": "BR",
        "value": "TO",
        "label": "Tocantins"
    },
    {
        "iso": "CA",
        "value": "AB",
        "label": "Alberta"
    },
    {
        "iso": "CA",
        "value": "BC",
        "label": "British Columbia"
    },
    {
        "iso": "CA",
        "value": "MB",
        "label": "Manitoba"
    },
    {
        "iso": "CA",
        "value": "NB",
        "label": "New Brunswick"
    },
    {
        "iso": "CA",
        "value": "NL",
        "label": "Newfoundland/Labrad."
    },
    {
        "iso": "CA",
        "value": "NS",
        "label": "Nova Scotia"
    },
    {
        "iso": "CA",
        "value": "NT",
        "label": "Northwest Territory"
    },
    {
        "iso": "CA",
        "value": "NU",
        "label": "Nunavut"
    },
    {
        "iso": "CA",
        "value": "ON",
        "label": "Ontario"
    },
    {
        "iso": "CA",
        "value": "PE",
        "label": "Prince Edward Island"
    },
    {
        "iso": "CA",
        "value": "QC",
        "label": "Quebec"
    },
    {
        "iso": "CA",
        "value": "SK",
        "label": "Saskatchewan"
    },
    {
        "iso": "CA",
        "value": "YT",
        "label": "Yukon Territory"
    },
    {
        "iso": "CH",
        "value": "AG",
        "label": "Aargau"
    },
    {
        "iso": "CH",
        "value": "AI",
        "label": "Inner-Rhoden"
    },
    {
        "iso": "CH",
        "value": "AR",
        "label": "Ausser-Rhoden"
    },
    {
        "iso": "CH",
        "value": "BE",
        "label": "Bern"
    },
    {
        "iso": "CH",
        "value": "BL",
        "label": "Basel Land"
    },
    {
        "iso": "CH",
        "value": "BS",
        "label": "Basel Stadt"
    },
    {
        "iso": "CH",
        "value": "FR",
        "label": "Fribourg"
    },
    {
        "iso": "CH",
        "value": "GE",
        "label": "Geneva"
    },
    {
        "iso": "CH",
        "value": "GL",
        "label": "Glarus"
    },
    {
        "iso": "CH",
        "value": "GR",
        "label": "Graubuenden"
    },
    {
        "iso": "CH",
        "value": "JU",
        "label": "Jura"
    },
    {
        "iso": "CH",
        "value": "LU",
        "label": "Lucerne"
    },
    {
        "iso": "CH",
        "value": "NE",
        "label": "Neuchatel"
    },
    {
        "iso": "CH",
        "value": "NW",
        "label": "Nidwalden"
    },
    {
        "iso": "CH",
        "value": "OW",
        "label": "Obwalden"
    },
    {
        "iso": "CH",
        "value": "SG",
        "label": "St. Gallen"
    },
    {
        "iso": "CH",
        "value": "SH",
        "label": "Schaffhausen"
    },
    {
        "iso": "CH",
        "value": "SO",
        "label": "Solothurn"
    },
    {
        "iso": "CH",
        "value": "SZ",
        "label": "Schwyz"
    },
    {
        "iso": "CH",
        "value": "TG",
        "label": "Thurgau"
    },
    {
        "iso": "CH",
        "value": "TI",
        "label": "Ticino"
    },
    {
        "iso": "CH",
        "value": "UR",
        "label": "Uri"
    },
    {
        "iso": "CH",
        "value": "VD",
        "label": "Vaud"
    },
    {
        "iso": "CH",
        "value": "VS",
        "label": "Valais"
    },
    {
        "iso": "CH",
        "value": "ZG",
        "label": "Zug"
    },
    {
        "iso": "CH",
        "value": "ZH",
        "label": "Zurich"
    },
    {
        "iso": "CL",
        "value": "1",
        "label": "I - Iquique"
    },
    {
        "iso": "CL",
        "value": "10",
        "label": "X - Puerto Montt"
    },
    {
        "iso": "CL",
        "value": "11",
        "label": "XI - Coyhaique"
    },
    {
        "iso": "CL",
        "value": "12",
        "label": "XII - Punta Arenas"
    },
    {
        "iso": "CL",
        "value": "13",
        "label": "RM - Santiago"
    },
    {
        "iso": "CL",
        "value": "14",
        "label": "XIV - Valdivia"
    },
    {
        "iso": "CL",
        "value": "15",
        "label": "XV - Arica"
    },
    {
        "iso": "CL",
        "value": "2",
        "label": "II - Antofagasta"
    },
    {
        "iso": "CL",
        "value": "3",
        "label": "III - Copiapo"
    },
    {
        "iso": "CL",
        "value": "4",
        "label": "IV - La Serena"
    },
    {
        "iso": "CL",
        "value": "5",
        "label": "V - Valparaiso"
    },
    {
        "iso": "CL",
        "value": "6",
        "label": "VI - Rancagua"
    },
    {
        "iso": "CL",
        "value": "7",
        "label": "VII - Talca"
    },
    {
        "iso": "CL",
        "value": "8",
        "label": "VIII - Concepcion"
    },
    {
        "iso": "CL",
        "value": "9",
        "label": "IX - Temuco"
    },
    {
        "iso": "CN",
        "value": "10",
        "label": "Beijing"
    },
    {
        "iso": "CN",
        "value": "20",
        "label": "Shanghai"
    },
    {
        "iso": "CN",
        "value": "30",
        "label": "Tianjin"
    },
    {
        "iso": "CN",
        "value": "40",
        "label": "Nei Mongol"
    },
    {
        "iso": "CN",
        "value": "50",
        "label": "Shanxi"
    },
    {
        "iso": "CN",
        "value": "60",
        "label": "Hebei"
    },
    {
        "iso": "CN",
        "value": "70",
        "label": "Liaoning"
    },
    {
        "iso": "CN",
        "value": "80",
        "label": "Jilin"
    },
    {
        "iso": "CN",
        "value": "90",
        "label": "Heilongjiang"
    },
    {
        "iso": "CN",
        "value": "100",
        "label": "Jiangsu"
    },
    {
        "iso": "CN",
        "value": "110",
        "label": "Anhui"
    },
    {
        "iso": "CN",
        "value": "120",
        "label": "Shandong"
    },
    {
        "iso": "CN",
        "value": "130",
        "label": "Zhejiang"
    },
    {
        "iso": "CN",
        "value": "140",
        "label": "Jiangxi"
    },
    {
        "iso": "CN",
        "value": "150",
        "label": "Fujian"
    },
    {
        "iso": "CN",
        "value": "160",
        "label": "Hunan"
    },
    {
        "iso": "CN",
        "value": "170",
        "label": "Hubei"
    },
    {
        "iso": "CN",
        "value": "180",
        "label": "Henan"
    },
    {
        "iso": "CN",
        "value": "190",
        "label": "Guangdong"
    },
    {
        "iso": "CN",
        "value": "200",
        "label": "Hainan"
    },
    {
        "iso": "CN",
        "value": "210",
        "label": "Guangxi"
    },
    {
        "iso": "CN",
        "value": "220",
        "label": "Guizhou"
    },
    {
        "iso": "CN",
        "value": "230",
        "label": "Sichuan"
    },
    {
        "iso": "CN",
        "value": "240",
        "label": "Yunnan"
    },
    {
        "iso": "CN",
        "value": "250",
        "label": "Shaanxi"
    },
    {
        "iso": "CN",
        "value": "260",
        "label": "Gansu"
    },
    {
        "iso": "CN",
        "value": "270",
        "label": "Ningxia"
    },
    {
        "iso": "CN",
        "value": "280",
        "label": "Qinghai"
    },
    {
        "iso": "CN",
        "value": "290",
        "label": "Xinjiang"
    },
    {
        "iso": "CN",
        "value": "300",
        "label": "Xizang"
    },
    {
        "iso": "CN",
        "value": "320",
        "label": "Chong Qing"
    },
    {
        "iso": "CO",
        "value": "5",
        "label": "ANTIOQUIA"
    },
    {
        "iso": "CO",
        "value": "8",
        "label": "ATLANTICO"
    },
    {
        "iso": "CO",
        "value": "11",
        "label": "BOGOTA"
    },
    {
        "iso": "CO",
        "value": "13",
        "label": "BOLIVAR"
    },
    {
        "iso": "CO",
        "value": "15",
        "label": "BOYACA"
    },
    {
        "iso": "CO",
        "value": "17",
        "label": "CALDAS"
    },
    {
        "iso": "CO",
        "value": "18",
        "label": "CAQUETA"
    },
    {
        "iso": "CO",
        "value": "19",
        "label": "CAUCA"
    },
    {
        "iso": "CO",
        "value": "20",
        "label": "CESAR"
    },
    {
        "iso": "CO",
        "value": "23",
        "label": "CORDOBA"
    },
    {
        "iso": "CO",
        "value": "25",
        "label": "CUNDINAMARCA"
    },
    {
        "iso": "CO",
        "value": "27",
        "label": "CHOCO"
    },
    {
        "iso": "CO",
        "value": "41",
        "label": "HUILA"
    },
    {
        "iso": "CO",
        "value": "44",
        "label": "LA GUAJIRA"
    },
    {
        "iso": "CO",
        "value": "47",
        "label": "MAGDALENA"
    },
    {
        "iso": "CO",
        "value": "50",
        "label": "META"
    },
    {
        "iso": "CO",
        "value": "52",
        "label": "NARINO"
    },
    {
        "iso": "CO",
        "value": "54",
        "label": "NORTE SANTANDER"
    },
    {
        "iso": "CO",
        "value": "63",
        "label": "QUINDIO"
    },
    {
        "iso": "CO",
        "value": "66",
        "label": "RISARALDA"
    },
    {
        "iso": "CO",
        "value": "68",
        "label": "SANTANDER"
    },
    {
        "iso": "CO",
        "value": "70",
        "label": "SUCRE"
    },
    {
        "iso": "CO",
        "value": "73",
        "label": "TOLIMA"
    },
    {
        "iso": "CO",
        "value": "76",
        "label": "VALLE"
    },
    {
        "iso": "CO",
        "value": "81",
        "label": "ARAUCA"
    },
    {
        "iso": "CO",
        "value": "85",
        "label": "CASANARE"
    },
    {
        "iso": "CO",
        "value": "86",
        "label": "PUTUMAYO"
    },
    {
        "iso": "CO",
        "value": "88",
        "label": "SAN ANDRES"
    },
    {
        "iso": "CO",
        "value": "91",
        "label": "AMAZONAS"
    },
    {
        "iso": "CO",
        "value": "94",
        "label": "GUAINIA"
    },
    {
        "iso": "CO",
        "value": "95",
        "label": "GUAVIARE"
    },
    {
        "iso": "CO",
        "value": "97",
        "label": "VAUPES"
    },
    {
        "iso": "CO",
        "value": "99",
        "label": "VICHADA"
    },
    {
        "iso": "CR",
        "value": "A",
        "label": "Alajuela"
    },
    {
        "iso": "CR",
        "value": "C",
        "label": "Cartago"
    },
    {
        "iso": "CR",
        "value": "G",
        "label": "Guanacaste"
    },
    {
        "iso": "CR",
        "value": "H",
        "label": "Heredia"
    },
    {
        "iso": "CR",
        "value": "L",
        "label": "Limón"
    },
    {
        "iso": "CR",
        "value": "P",
        "label": "Puntarenas"
    },
    {
        "iso": "CR",
        "value": "SJ",
        "label": "San José"
    },
    {
        "iso": "CZ",
        "value": "11",
        "label": "Praha"
    },
    {
        "iso": "CZ",
        "value": "21",
        "label": "Stredocesky"
    },
    {
        "iso": "CZ",
        "value": "31",
        "label": "Jihocesky"
    },
    {
        "iso": "CZ",
        "value": "32",
        "label": "Plzensky"
    },
    {
        "iso": "CZ",
        "value": "41",
        "label": "Karlovarsky"
    },
    {
        "iso": "CZ",
        "value": "42",
        "label": "Ustecky"
    },
    {
        "iso": "CZ",
        "value": "51",
        "label": "Liberecky"
    },
    {
        "iso": "CZ",
        "value": "52",
        "label": "Kralovehradecky"
    },
    {
        "iso": "CZ",
        "value": "53",
        "label": "Pardubicky"
    },
    {
        "iso": "CZ",
        "value": "61",
        "label": "Vysocina"
    },
    {
        "iso": "CZ",
        "value": "62",
        "label": "Jihomoravsky"
    },
    {
        "iso": "CZ",
        "value": "71",
        "label": "Olomoucky"
    },
    {
        "iso": "CZ",
        "value": "72",
        "label": "Zlinsky"
    },
    {
        "iso": "CZ",
        "value": "81",
        "label": "Moravskoslezsky"
    },
    {
        "iso": "DE",
        "value": "1",
        "label": "Schleswig-Holstein"
    },
    {
        "iso": "DE",
        "value": "2",
        "label": "Hamburg"
    },
    {
        "iso": "DE",
        "value": "3",
        "label": "Lower Saxony"
    },
    {
        "iso": "DE",
        "value": "4",
        "label": "Bremen"
    },
    {
        "iso": "DE",
        "value": "5",
        "label": "North Rhine-Westph."
    },
    {
        "iso": "DE",
        "value": "6",
        "label": "Hessen"
    },
    {
        "iso": "DE",
        "value": "7",
        "label": "Rhineland Palatinate"
    },
    {
        "iso": "DE",
        "value": "8",
        "label": "Baden-Wurttemberg"
    },
    {
        "iso": "DE",
        "value": "9",
        "label": "Bavaria"
    },
    {
        "iso": "DE",
        "value": "10",
        "label": "Saarland"
    },
    {
        "iso": "DE",
        "value": "11",
        "label": "Berlin"
    },
    {
        "iso": "DE",
        "value": "12",
        "label": "Brandenburg"
    },
    {
        "iso": "DE",
        "value": "13",
        "label": "Mecklenburg-Vorpomm."
    },
    {
        "iso": "DE",
        "value": "14",
        "label": "Saxony"
    },
    {
        "iso": "DE",
        "value": "15",
        "label": "Saxony-Anhalt"
    },
    {
        "iso": "DE",
        "value": "16",
        "label": "Thuringia"
    },
    {
        "iso": "DK",
        "value": "1",
        "label": "Copenhagen"
    },
    {
        "iso": "DK",
        "value": "2",
        "label": "Central Jutland"
    },
    {
        "iso": "DK",
        "value": "3",
        "label": "North Jutland"
    },
    {
        "iso": "DK",
        "value": "4",
        "label": "Zealand"
    },
    {
        "iso": "DK",
        "value": "5",
        "label": "South Denmark"
    },
    {
        "iso": "DO",
        "value": "32",
        "label": "Santo Domingo"
    },
    {
        "iso": "EE",
        "value": "37",
        "label": "Harju"
    },
    {
        "iso": "EE",
        "value": "39",
        "label": "Hiiu"
    },
    {
        "iso": "EE",
        "value": "44",
        "label": "Ida-Viru"
    },
    {
        "iso": "EE",
        "value": "49",
        "label": "JÃµgeva"
    },
    {
        "iso": "EE",
        "value": "51",
        "label": "JÃ¤rva"
    },
    {
        "iso": "EE",
        "value": "57",
        "label": "LÃ¤Ã¤ne"
    },
    {
        "iso": "EE",
        "value": "59",
        "label": "LÃ¤Ã¤ne-Viru"
    },
    {
        "iso": "EE",
        "value": "65",
        "label": "PÃµlva"
    },
    {
        "iso": "EE",
        "value": "67",
        "label": "PÃ¤rnu"
    },
    {
        "iso": "EE",
        "value": "70",
        "label": "Rapla"
    },
    {
        "iso": "EE",
        "value": "74",
        "label": "Saare"
    },
    {
        "iso": "EE",
        "value": "78",
        "label": "Tartu"
    },
    {
        "iso": "EE",
        "value": "82",
        "label": "Valga"
    },
    {
        "iso": "EE",
        "value": "84",
        "label": "Viljandi"
    },
    {
        "iso": "EE",
        "value": "86",
        "label": "VÃµru"
    },
    {
        "iso": "ES",
        "value": "1",
        "label": "Alava"
    },
    {
        "iso": "ES",
        "value": "2",
        "label": "Albacete"
    },
    {
        "iso": "ES",
        "value": "3",
        "label": "Alicante"
    },
    {
        "iso": "ES",
        "value": "4",
        "label": "Almeria"
    },
    {
        "iso": "ES",
        "value": "5",
        "label": "Avila"
    },
    {
        "iso": "ES",
        "value": "6",
        "label": "Badajoz"
    },
    {
        "iso": "ES",
        "value": "7",
        "label": "Baleares"
    },
    {
        "iso": "ES",
        "value": "8",
        "label": "Barcelona"
    },
    {
        "iso": "ES",
        "value": "9",
        "label": "Burgos"
    },
    {
        "iso": "ES",
        "value": "10",
        "label": "Caceres"
    },
    {
        "iso": "ES",
        "value": "11",
        "label": "Cadiz"
    },
    {
        "iso": "ES",
        "value": "12",
        "label": "Castellon"
    },
    {
        "iso": "ES",
        "value": "13",
        "label": "Ciudad Real"
    },
    {
        "iso": "ES",
        "value": "14",
        "label": "Cordoba"
    },
    {
        "iso": "ES",
        "value": "15",
        "label": "La CoruNa"
    },
    {
        "iso": "ES",
        "value": "16",
        "label": "Cuenca"
    },
    {
        "iso": "ES",
        "value": "17",
        "label": "Gerona"
    },
    {
        "iso": "ES",
        "value": "18",
        "label": "Granada"
    },
    {
        "iso": "ES",
        "value": "19",
        "label": "Guadalajara"
    },
    {
        "iso": "ES",
        "value": "20",
        "label": "Guipuzcoa"
    },
    {
        "iso": "ES",
        "value": "21",
        "label": "Huelva"
    },
    {
        "iso": "ES",
        "value": "22",
        "label": "Huesca"
    },
    {
        "iso": "ES",
        "value": "23",
        "label": "Jaen"
    },
    {
        "iso": "ES",
        "value": "24",
        "label": "Leon"
    },
    {
        "iso": "ES",
        "value": "25",
        "label": "Lerida"
    },
    {
        "iso": "ES",
        "value": "26",
        "label": "La Rioja"
    },
    {
        "iso": "ES",
        "value": "27",
        "label": "Lugo"
    },
    {
        "iso": "ES",
        "value": "28",
        "label": "Madrid"
    },
    {
        "iso": "ES",
        "value": "29",
        "label": "Malaga"
    },
    {
        "iso": "ES",
        "value": "30",
        "label": "Murcia"
    },
    {
        "iso": "ES",
        "value": "31",
        "label": "Navarra"
    },
    {
        "iso": "ES",
        "value": "32",
        "label": "Orense"
    },
    {
        "iso": "ES",
        "value": "33",
        "label": "Asturias"
    },
    {
        "iso": "ES",
        "value": "34",
        "label": "Palencia"
    },
    {
        "iso": "ES",
        "value": "35",
        "label": "Las Palmas"
    },
    {
        "iso": "ES",
        "value": "36",
        "label": "Pontevedra"
    },
    {
        "iso": "ES",
        "value": "37",
        "label": "Salamanca"
    },
    {
        "iso": "ES",
        "value": "38",
        "label": "Sta. Cruz Tenerife"
    },
    {
        "iso": "ES",
        "value": "39",
        "label": "Cantabria"
    },
    {
        "iso": "ES",
        "value": "40",
        "label": "Segovia"
    },
    {
        "iso": "ES",
        "value": "41",
        "label": "Sevilla"
    },
    {
        "iso": "ES",
        "value": "42",
        "label": "Soria"
    },
    {
        "iso": "ES",
        "value": "43",
        "label": "Tarragona"
    },
    {
        "iso": "ES",
        "value": "44",
        "label": "Teruel"
    },
    {
        "iso": "ES",
        "value": "45",
        "label": "Toledo"
    },
    {
        "iso": "ES",
        "value": "46",
        "label": "Valencia"
    },
    {
        "iso": "ES",
        "value": "47",
        "label": "Valladolid"
    },
    {
        "iso": "ES",
        "value": "48",
        "label": "Vizcaya"
    },
    {
        "iso": "ES",
        "value": "49",
        "label": "Zamora"
    },
    {
        "iso": "ES",
        "value": "50",
        "label": "Zaragoza"
    },
    {
        "iso": "FI",
        "value": "1",
        "label": "Ahvenanmaa(obsolete)"
    },
    {
        "iso": "FI",
        "value": "2",
        "label": "Etela-Suo.(obsolete)"
    },
    {
        "iso": "FI",
        "value": "3",
        "label": "Ita-Suomi(obsolete)"
    },
    {
        "iso": "FI",
        "value": "4",
        "label": "Lappi(obsolete)"
    },
    {
        "iso": "FI",
        "value": "5",
        "label": "Lansi-Suo.(obsolete)"
    },
    {
        "iso": "FI",
        "value": "6",
        "label": "Oulu(obsolete)"
    },
    {
        "iso": "FR",
        "value": "1",
        "label": "Ain"
    },
    {
        "iso": "FR",
        "value": "2",
        "label": "Aisne"
    },
    {
        "iso": "FR",
        "value": "3",
        "label": "Allier"
    },
    {
        "iso": "FR",
        "value": "4",
        "label": "Alpes (Hte-Provence)"
    },
    {
        "iso": "FR",
        "value": "5",
        "label": "Alpes (Hautes)"
    },
    {
        "iso": "FR",
        "value": "6",
        "label": "Alpes-Maritimes"
    },
    {
        "iso": "FR",
        "value": "7",
        "label": "Ardeche"
    },
    {
        "iso": "FR",
        "value": "8",
        "label": "Ardennes"
    },
    {
        "iso": "FR",
        "value": "9",
        "label": "Ariege"
    },
    {
        "iso": "FR",
        "value": "10",
        "label": "Aube"
    },
    {
        "iso": "FR",
        "value": "11",
        "label": "Aude"
    },
    {
        "iso": "FR",
        "value": "12",
        "label": "Aveyron"
    },
    {
        "iso": "FR",
        "value": "13",
        "label": "Bouches-du-Rhone"
    },
    {
        "iso": "FR",
        "value": "14",
        "label": "Calvados"
    },
    {
        "iso": "FR",
        "value": "15",
        "label": "Cantal"
    },
    {
        "iso": "FR",
        "value": "16",
        "label": "Charente"
    },
    {
        "iso": "FR",
        "value": "17",
        "label": "Charente-Maritime"
    },
    {
        "iso": "FR",
        "value": "18",
        "label": "Cher"
    },
    {
        "iso": "FR",
        "value": "19",
        "label": "Correze"
    },
    {
        "iso": "FR",
        "value": "21",
        "label": "Cote-d'Or"
    },
    {
        "iso": "FR",
        "value": "22",
        "label": "Cotes-d'Armor"
    },
    {
        "iso": "FR",
        "value": "23",
        "label": "Creuse"
    },
    {
        "iso": "FR",
        "value": "24",
        "label": "Dordogne"
    },
    {
        "iso": "FR",
        "value": "25",
        "label": "Doubs"
    },
    {
        "iso": "FR",
        "value": "26",
        "label": "Drome"
    },
    {
        "iso": "FR",
        "value": "27",
        "label": "Eure"
    },
    {
        "iso": "FR",
        "value": "28",
        "label": "Eure-et-Loir"
    },
    {
        "iso": "FR",
        "value": "29",
        "label": "Finistere"
    },
    {
        "iso": "FR",
        "value": "2A",
        "label": "Corse-du-Sud"
    },
    {
        "iso": "FR",
        "value": "2B",
        "label": "Corse-du-Nord"
    },
    {
        "iso": "FR",
        "value": "30",
        "label": "Gard"
    },
    {
        "iso": "FR",
        "value": "31",
        "label": "Garonne (Haute)"
    },
    {
        "iso": "FR",
        "value": "32",
        "label": "Gers"
    },
    {
        "iso": "FR",
        "value": "33",
        "label": "Gironde"
    },
    {
        "iso": "FR",
        "value": "34",
        "label": "Herault"
    },
    {
        "iso": "FR",
        "value": "35",
        "label": "Ille-et-Vilaine"
    },
    {
        "iso": "FR",
        "value": "36",
        "label": "Indre"
    },
    {
        "iso": "FR",
        "value": "37",
        "label": "Indre-et-Loire"
    },
    {
        "iso": "FR",
        "value": "38",
        "label": "Isere"
    },
    {
        "iso": "FR",
        "value": "39",
        "label": "Jura"
    },
    {
        "iso": "FR",
        "value": "40",
        "label": "Landes"
    },
    {
        "iso": "FR",
        "value": "41",
        "label": "Loir-et-Cher"
    },
    {
        "iso": "FR",
        "value": "42",
        "label": "Loire"
    },
    {
        "iso": "FR",
        "value": "43",
        "label": "Loire (Haute)"
    },
    {
        "iso": "FR",
        "value": "44",
        "label": "Loire-Atlantique"
    },
    {
        "iso": "FR",
        "value": "45",
        "label": "Loiret"
    },
    {
        "iso": "FR",
        "value": "46",
        "label": "Lot"
    },
    {
        "iso": "FR",
        "value": "47",
        "label": "Lot-et-Garonne"
    },
    {
        "iso": "FR",
        "value": "48",
        "label": "Lozere"
    },
    {
        "iso": "FR",
        "value": "49",
        "label": "Maine-et-Loire"
    },
    {
        "iso": "FR",
        "value": "50",
        "label": "Manche"
    },
    {
        "iso": "FR",
        "value": "51",
        "label": "Marne"
    },
    {
        "iso": "FR",
        "value": "52",
        "label": "Marne (Haute)"
    },
    {
        "iso": "FR",
        "value": "53",
        "label": "Mayenne"
    },
    {
        "iso": "FR",
        "value": "54",
        "label": "Meurthe-et-Moselle"
    },
    {
        "iso": "FR",
        "value": "55",
        "label": "Meuse"
    },
    {
        "iso": "FR",
        "value": "56",
        "label": "Morbihan"
    },
    {
        "iso": "FR",
        "value": "57",
        "label": "Moselle"
    },
    {
        "iso": "FR",
        "value": "58",
        "label": "Nievre"
    },
    {
        "iso": "FR",
        "value": "59",
        "label": "Nord"
    },
    {
        "iso": "FR",
        "value": "60",
        "label": "Oise"
    },
    {
        "iso": "FR",
        "value": "61",
        "label": "Orne"
    },
    {
        "iso": "FR",
        "value": "62",
        "label": "Pas-de-Calais"
    },
    {
        "iso": "FR",
        "value": "63",
        "label": "Puy-de-Dome"
    },
    {
        "iso": "FR",
        "value": "64",
        "label": "Pyrenees-Atlantiques"
    },
    {
        "iso": "FR",
        "value": "65",
        "label": "Pyrenees (Hautes)"
    },
    {
        "iso": "FR",
        "value": "66",
        "label": "Pyrenees-Orientales"
    },
    {
        "iso": "FR",
        "value": "67",
        "label": "Bas-Rhin"
    },
    {
        "iso": "FR",
        "value": "68",
        "label": "Haut-Rhin"
    },
    {
        "iso": "FR",
        "value": "69",
        "label": "Rhone"
    },
    {
        "iso": "FR",
        "value": "70",
        "label": "Saone (Haute)"
    },
    {
        "iso": "FR",
        "value": "71",
        "label": "Saone-et-Loire"
    },
    {
        "iso": "FR",
        "value": "72",
        "label": "Sarthe"
    },
    {
        "iso": "FR",
        "value": "73",
        "label": "Savoie"
    },
    {
        "iso": "FR",
        "value": "74",
        "label": "Savoie (Haute)"
    },
    {
        "iso": "FR",
        "value": "75",
        "label": "Paris"
    },
    {
        "iso": "FR",
        "value": "76",
        "label": "Seine-Maritime"
    },
    {
        "iso": "FR",
        "value": "77",
        "label": "Seine-et-Marne"
    },
    {
        "iso": "FR",
        "value": "78",
        "label": "Yvelines"
    },
    {
        "iso": "FR",
        "value": "79",
        "label": "Sevres (Deux)"
    },
    {
        "iso": "FR",
        "value": "80",
        "label": "Somme"
    },
    {
        "iso": "FR",
        "value": "81",
        "label": "Tarn"
    },
    {
        "iso": "FR",
        "value": "82",
        "label": "Tarn-et-Garonne"
    },
    {
        "iso": "FR",
        "value": "83",
        "label": "Var"
    },
    {
        "iso": "FR",
        "value": "84",
        "label": "Vaucluse"
    },
    {
        "iso": "FR",
        "value": "85",
        "label": "Vendee"
    },
    {
        "iso": "FR",
        "value": "86",
        "label": "Vienne"
    },
    {
        "iso": "FR",
        "value": "87",
        "label": "Vienne (Haute)"
    },
    {
        "iso": "FR",
        "value": "88",
        "label": "Vosges"
    },
    {
        "iso": "FR",
        "value": "89",
        "label": "Yonne"
    },
    {
        "iso": "FR",
        "value": "90",
        "label": "Territ.-de-Belfort"
    },
    {
        "iso": "FR",
        "value": "91",
        "label": "Essonne"
    },
    {
        "iso": "FR",
        "value": "92",
        "label": "Hauts-de-Seine"
    },
    {
        "iso": "FR",
        "value": "93",
        "label": "Seine-Saint-Denis"
    },
    {
        "iso": "FR",
        "value": "94",
        "label": "Val-de-Marne"
    },
    {
        "iso": "FR",
        "value": "95",
        "label": "Val-d'Oise"
    },
    {
        "iso": "FR",
        "value": "97",
        "label": "D.O.M.-T.O.M."
    },
    {
        "iso": "FR",
        "value": "971",
        "label": "Guadeloupe"
    },
    {
        "iso": "FR",
        "value": "972",
        "label": "Martinique"
    },
    {
        "iso": "FR",
        "value": "973",
        "label": "Guyane"
    },
    {
        "iso": "FR",
        "value": "974",
        "label": "Reunion"
    },
    {
        "iso": "FR",
        "value": "975",
        "label": "Saint-Pierre-et-Miq."
    },
    {
        "iso": "FR",
        "value": "976",
        "label": "Wallis-et-Futuna"
    },
    {
        "iso": "FR",
        "value": "99",
        "label": "Hors-France"
    },
    {
        "iso": "GB",
        "value": "AB",
        "label": "Aberdeenshire"
    },
    {
        "iso": "GB",
        "value": "AG",
        "label": "Argyllshire"
    },
    {
        "iso": "GB",
        "value": "AL",
        "label": "Anglesey"
    },
    {
        "iso": "GB",
        "value": "AM",
        "label": "Armagh"
    },
    {
        "iso": "GB",
        "value": "AN",
        "label": "Angus/Forfarshire"
    },
    {
        "iso": "GB",
        "value": "AT",
        "label": "Antrim"
    },
    {
        "iso": "GB",
        "value": "AY",
        "label": "Ayrshire"
    },
    {
        "iso": "GB",
        "value": "BE",
        "label": "Bedfordshire"
    },
    {
        "iso": "GB",
        "value": "BF",
        "label": "Banffshire"
    },
    {
        "iso": "GB",
        "value": "BK",
        "label": "Berkshire"
    },
    {
        "iso": "GB",
        "value": "BR",
        "label": "Brecknockshire"
    },
    {
        "iso": "GB",
        "value": "BS",
        "label": "Bath&NthEstSomerset"
    },
    {
        "iso": "GB",
        "value": "BT",
        "label": "Buteshire"
    },
    {
        "iso": "GB",
        "value": "BU",
        "label": "Buckinghamshire"
    },
    {
        "iso": "GB",
        "value": "BW",
        "label": "Berwickshire"
    },
    {
        "iso": "GB",
        "value": "C4",
        "label": "Channel Isles"
    },
    {
        "iso": "GB",
        "value": "CA",
        "label": "Cambridgeshire"
    },
    {
        "iso": "GB",
        "value": "CB",
        "label": "Carmarthenshire"
    },
    {
        "iso": "GB",
        "value": "CD",
        "label": "Cardiganshire"
    },
    {
        "iso": "GB",
        "value": "CF",
        "label": "Caernarfonshire"
    },
    {
        "iso": "GB",
        "value": "CH",
        "label": "Cheshire"
    },
    {
        "iso": "GB",
        "value": "CM",
        "label": "Cromartyshire"
    },
    {
        "iso": "GB",
        "value": "CN",
        "label": "Clackmannanshire"
    },
    {
        "iso": "GB",
        "value": "CO",
        "label": "Cornwall"
    },
    {
        "iso": "GB",
        "value": "CT",
        "label": "Caithness"
    },
    {
        "iso": "GB",
        "value": "CU",
        "label": "Cumberland"
    },
    {
        "iso": "GB",
        "value": "DB",
        "label": "Derbyshire"
    },
    {
        "iso": "GB",
        "value": "DD",
        "label": "Denbighshire"
    },
    {
        "iso": "GB",
        "value": "DF",
        "label": "Dumfriesshire"
    },
    {
        "iso": "GB",
        "value": "DN",
        "label": "Down"
    },
    {
        "iso": "GB",
        "value": "DO",
        "label": "Dorset"
    },
    {
        "iso": "GB",
        "value": "DT",
        "label": "Dunbartonshire"
    },
    {
        "iso": "GB",
        "value": "DU",
        "label": "Durham"
    },
    {
        "iso": "GB",
        "value": "DV",
        "label": "Devon"
    },
    {
        "iso": "GB",
        "value": "EL",
        "label": "East Lothian"
    },
    {
        "iso": "GB",
        "value": "ER",
        "label": "East Yorkshire"
    },
    {
        "iso": "GB",
        "value": "ES",
        "label": "Essex"
    },
    {
        "iso": "GB",
        "value": "FI",
        "label": "Fife"
    },
    {
        "iso": "GB",
        "value": "FL",
        "label": "Flintshire"
    },
    {
        "iso": "GB",
        "value": "FM",
        "label": "Fermanagh"
    },
    {
        "iso": "GB",
        "value": "GL",
        "label": "Gloucestershire"
    },
    {
        "iso": "GB",
        "value": "HA",
        "label": "Hampshire"
    },
    {
        "iso": "GB",
        "value": "HT",
        "label": "Hertfordshire"
    },
    {
        "iso": "GB",
        "value": "HU",
        "label": "Huntingdonshire"
    },
    {
        "iso": "GB",
        "value": "HW",
        "label": "Hereford and Worcs."
    },
    {
        "iso": "GB",
        "value": "IN",
        "label": "Invernesshire"
    },
    {
        "iso": "GB",
        "value": "IW",
        "label": "Isle of Wight"
    },
    {
        "iso": "GB",
        "value": "KE",
        "label": "Kent"
    },
    {
        "iso": "GB",
        "value": "KI",
        "label": "Kincardineshire"
    },
    {
        "iso": "GB",
        "value": "KK",
        "label": "Kirkcudbrightshire"
    },
    {
        "iso": "GB",
        "value": "KN",
        "label": "Kinross-shire"
    },
    {
        "iso": "GB",
        "value": "LA",
        "label": "Lancashire"
    },
    {
        "iso": "GB",
        "value": "LC",
        "label": "London"
    },
    {
        "iso": "GB",
        "value": "LD",
        "label": "Londonderry"
    },
    {
        "iso": "GB",
        "value": "LE",
        "label": "Leicestershire"
    },
    {
        "iso": "GB",
        "value": "LI",
        "label": "Lincolnshire"
    },
    {
        "iso": "GB",
        "value": "LN",
        "label": "Lanarkshire"
    },
    {
        "iso": "GB",
        "value": "MD",
        "label": "Midlothian"
    },
    {
        "iso": "GB",
        "value": "ME",
        "label": "Merioneth"
    },
    {
        "iso": "GB",
        "value": "MG",
        "label": "Mid Glamorgan"
    },
    {
        "iso": "GB",
        "value": "MM",
        "label": "Monmouthshire"
    },
    {
        "iso": "GB",
        "value": "MR",
        "label": "Morayshire"
    },
    {
        "iso": "GB",
        "value": "MT",
        "label": "Montgomeryshire"
    },
    {
        "iso": "GB",
        "value": "MX",
        "label": "Middlesex"
    },
    {
        "iso": "GB",
        "value": "NH",
        "label": "Northamptonshire"
    },
    {
        "iso": "GB",
        "value": "NK",
        "label": "Norfolk"
    },
    {
        "iso": "GB",
        "value": "NR",
        "label": "Nairnshire"
    },
    {
        "iso": "GB",
        "value": "NT",
        "label": "Nottinghamshire"
    },
    {
        "iso": "GB",
        "value": "NU",
        "label": "Northumberland"
    },
    {
        "iso": "GB",
        "value": "OR",
        "label": "Orkney"
    },
    {
        "iso": "GB",
        "value": "OX",
        "label": "Oxfordshire"
    },
    {
        "iso": "GB",
        "value": "PE",
        "label": "Peeblesshire"
    },
    {
        "iso": "GB",
        "value": "PM",
        "label": "Pembrokeshire"
    },
    {
        "iso": "GB",
        "value": "PR",
        "label": "Perthshire"
    },
    {
        "iso": "GB",
        "value": "RA",
        "label": "Radnorshire"
    },
    {
        "iso": "GB",
        "value": "RE",
        "label": "Renfrewshire"
    },
    {
        "iso": "GB",
        "value": "RO",
        "label": "Ross-shire"
    },
    {
        "iso": "GB",
        "value": "RU",
        "label": "Rutland"
    },
    {
        "iso": "GB",
        "value": "RX",
        "label": "Roxburghshire"
    },
    {
        "iso": "GB",
        "value": "SE",
        "label": "East Sussex"
    },
    {
        "iso": "GB",
        "value": "SF",
        "label": "Selkirkshire"
    },
    {
        "iso": "GB",
        "value": "SG",
        "label": "South Glamorgan"
    },
    {
        "iso": "GB",
        "value": "SH",
        "label": "Shropshire"
    },
    {
        "iso": "GB",
        "value": "SK",
        "label": "Suffolk"
    },
    {
        "iso": "GB",
        "value": "SL",
        "label": "Shetland"
    },
    {
        "iso": "GB",
        "value": "SO",
        "label": "Somerset"
    },
    {
        "iso": "GB",
        "value": "ST",
        "label": "Staffordshire"
    },
    {
        "iso": "GB",
        "value": "SU",
        "label": "Sutherland"
    },
    {
        "iso": "GB",
        "value": "SV",
        "label": "Stirlingshire"
    },
    {
        "iso": "GB",
        "value": "SW",
        "label": "West Sussex"
    },
    {
        "iso": "GB",
        "value": "SY",
        "label": "Surrey"
    },
    {
        "iso": "GB",
        "value": "TY",
        "label": "Tyrone"
    },
    {
        "iso": "GB",
        "value": "W1",
        "label": "West Midlands"
    },
    {
        "iso": "GB",
        "value": "WA",
        "label": "Warwickshire"
    },
    {
        "iso": "GB",
        "value": "WC",
        "label": "Worcestershire"
    },
    {
        "iso": "GB",
        "value": "WE",
        "label": "Westmorland"
    },
    {
        "iso": "GB",
        "value": "WG",
        "label": "West Glamorgan"
    },
    {
        "iso": "GB",
        "value": "WI",
        "label": "Wiltshire"
    },
    {
        "iso": "GB",
        "value": "WK",
        "label": "West Lothian"
    },
    {
        "iso": "GB",
        "value": "WS",
        "label": "Westminster"
    },
    {
        "iso": "GB",
        "value": "WT",
        "label": "Wigtownshire"
    },
    {
        "iso": "GB",
        "value": "YN",
        "label": "North Yorkshire"
    },
    {
        "iso": "GB",
        "value": "YS",
        "label": "South Yorkshire"
    },
    {
        "iso": "GB",
        "value": "YW",
        "label": "West Yorkshire"
    },
    {
        "iso": "GH",
        "value": "AF",
        "label": "Ahafo"
    },
    {
        "iso": "GH",
        "value": "BE",
        "label": "Bono East"
    },
    {
        "iso": "GH",
        "value": "BO",
        "label": "Bono"
    },
    {
        "iso": "GH",
        "value": "NE",
        "label": "North East"
    },
    {
        "iso": "GH",
        "value": "OT",
        "label": "Oti"
    },
    {
        "iso": "GH",
        "value": "SV",
        "label": "Savannah"
    },
    {
        "iso": "GH",
        "value": "WN",
        "label": "Western North"
    },
    {
        "iso": "GR",
        "value": "1",
        "label": "Aitolia kai Akarnan."
    },
    {
        "iso": "GR",
        "value": "2",
        "label": "Akhaia"
    },
    {
        "iso": "GR",
        "value": "3",
        "label": "Argolis"
    },
    {
        "iso": "GR",
        "value": "4",
        "label": "Arkadhia"
    },
    {
        "iso": "GR",
        "value": "5",
        "label": "Arta"
    },
    {
        "iso": "GR",
        "value": "6",
        "label": "Attiki"
    },
    {
        "iso": "GR",
        "value": "7",
        "label": "Dhodhekanisos"
    },
    {
        "iso": "GR",
        "value": "8",
        "label": "Dhrama"
    },
    {
        "iso": "GR",
        "value": "9",
        "label": "Evritania"
    },
    {
        "iso": "GR",
        "value": "10",
        "label": "Evros"
    },
    {
        "iso": "GR",
        "value": "11",
        "label": "Evvoia"
    },
    {
        "iso": "GR",
        "value": "12",
        "label": "Florina"
    },
    {
        "iso": "GR",
        "value": "13",
        "label": "Fokis"
    },
    {
        "iso": "GR",
        "value": "14",
        "label": "Fthiotis"
    },
    {
        "iso": "GR",
        "value": "15",
        "label": "Grevena"
    },
    {
        "iso": "GR",
        "value": "16",
        "label": "Ilia"
    },
    {
        "iso": "GR",
        "value": "17",
        "label": "Imathia"
    },
    {
        "iso": "GR",
        "value": "18",
        "label": "Ioannina"
    },
    {
        "iso": "GR",
        "value": "19",
        "label": "Iraklion"
    },
    {
        "iso": "GR",
        "value": "20",
        "label": "Kardhitsa"
    },
    {
        "iso": "GR",
        "value": "21",
        "label": "Kastoria"
    },
    {
        "iso": "GR",
        "value": "22",
        "label": "Kavala"
    },
    {
        "iso": "GR",
        "value": "23",
        "label": "Kefallinia"
    },
    {
        "iso": "GR",
        "value": "24",
        "label": "Kerkira"
    },
    {
        "iso": "GR",
        "value": "25",
        "label": "Khalkidhiki"
    },
    {
        "iso": "GR",
        "value": "26",
        "label": "Khania"
    },
    {
        "iso": "GR",
        "value": "27",
        "label": "Khios"
    },
    {
        "iso": "GR",
        "value": "28",
        "label": "Kikladhes"
    },
    {
        "iso": "GR",
        "value": "29",
        "label": "Kilkis"
    },
    {
        "iso": "GR",
        "value": "30",
        "label": "Korinthia"
    },
    {
        "iso": "GR",
        "value": "31",
        "label": "Kozani"
    },
    {
        "iso": "GR",
        "value": "32",
        "label": "Lakonia"
    },
    {
        "iso": "GR",
        "value": "33",
        "label": "Larisa"
    },
    {
        "iso": "GR",
        "value": "34",
        "label": "Lasithi"
    },
    {
        "iso": "GR",
        "value": "35",
        "label": "Lesvos"
    },
    {
        "iso": "GR",
        "value": "36",
        "label": "Levkas"
    },
    {
        "iso": "GR",
        "value": "37",
        "label": "Magnisia"
    },
    {
        "iso": "GR",
        "value": "38",
        "label": "Messinia"
    },
    {
        "iso": "GR",
        "value": "39",
        "label": "Pella"
    },
    {
        "iso": "GR",
        "value": "40",
        "label": "Pieria"
    },
    {
        "iso": "GR",
        "value": "42",
        "label": "Preveza"
    },
    {
        "iso": "GR",
        "value": "43",
        "label": "Rethimni"
    },
    {
        "iso": "GR",
        "value": "44",
        "label": "Rodhopi"
    },
    {
        "iso": "GR",
        "value": "45",
        "label": "Samos"
    },
    {
        "iso": "GR",
        "value": "46",
        "label": "Serrai"
    },
    {
        "iso": "GR",
        "value": "47",
        "label": "Thesprotia"
    },
    {
        "iso": "GR",
        "value": "48",
        "label": "Thessaloniki"
    },
    {
        "iso": "GR",
        "value": "49",
        "label": "Trikala"
    },
    {
        "iso": "GR",
        "value": "50",
        "label": "Voiotia"
    },
    {
        "iso": "GR",
        "value": "51",
        "label": "Xanthi"
    },
    {
        "iso": "GR",
        "value": "52",
        "label": "Zakinthos"
    },
    {
        "iso": "GT",
        "value": "GU",
        "label": "Guatemala"
    },
    {
        "iso": "HK",
        "value": "HK",
        "label": "Hong Kong Island"
    },
    {
        "iso": "HK",
        "value": "KLN",
        "label": "Kowloon"
    },
    {
        "iso": "HK",
        "value": "NT",
        "label": "New Territories"
    },
    {
        "iso": "HR",
        "value": "A00",
        "label": "Zagreb"
    },
    {
        "iso": "HR",
        "value": "C00",
        "label": "Sisak-Moslavina"
    },
    {
        "iso": "HR",
        "value": "D00",
        "label": "Karlovac"
    },
    {
        "iso": "HR",
        "value": "E00",
        "label": "Varazdin"
    },
    {
        "iso": "HR",
        "value": "F00",
        "label": "Koprivnica-Krizevci"
    },
    {
        "iso": "HR",
        "value": "G00",
        "label": "Bjelovar-Bilogora"
    },
    {
        "iso": "HR",
        "value": "I00",
        "label": "Lika-Senj"
    },
    {
        "iso": "HR",
        "value": "J00",
        "label": "Virovitica-Podravina"
    },
    {
        "iso": "HR",
        "value": "K00",
        "label": "Pozega-Slavonija"
    },
    {
        "iso": "HR",
        "value": "L00",
        "label": "Slavonski"
    },
    {
        "iso": "HR",
        "value": "N00",
        "label": "Osijek-Baranja"
    },
    {
        "iso": "HR",
        "value": "O00",
        "label": "Sibenik"
    },
    {
        "iso": "HR",
        "value": "P00",
        "label": "Vukovar-Srijem"
    },
    {
        "iso": "HR",
        "value": "R00",
        "label": "Split-Dalmatia"
    },
    {
        "iso": "HR",
        "value": "S00",
        "label": "Istra"
    },
    {
        "iso": "HR",
        "value": "T00",
        "label": "Dubrovnik-Neretva"
    },
    {
        "iso": "HR",
        "value": "U00",
        "label": "Medimurje"
    },
    {
        "iso": "HR",
        "value": "V00",
        "label": "Stadt Zagreb"
    },
    {
        "iso": "HR",
        "value": "ZB0",
        "label": "Krapinsko-zagorska"
    },
    {
        "iso": "HR",
        "value": "ZH0",
        "label": "Rijecko-goranska"
    },
    {
        "iso": "HR",
        "value": "ZM0",
        "label": "Zadarska"
    },
    {
        "iso": "HT",
        "value": "SE",
        "label": "Sud-Est"
    },
    {
        "iso": "HU",
        "value": "1",
        "label": "Bacs-Kiskun"
    },
    {
        "iso": "HU",
        "value": "2",
        "label": "Baranya"
    },
    {
        "iso": "HU",
        "value": "3",
        "label": "Bekes"
    },
    {
        "iso": "HU",
        "value": "4",
        "label": "Bekescsaba"
    },
    {
        "iso": "HU",
        "value": "5",
        "label": "Borsod-Abauj-Zemplen"
    },
    {
        "iso": "HU",
        "value": "6",
        "label": "Budapest"
    },
    {
        "iso": "HU",
        "value": "7",
        "label": "Csongrad"
    },
    {
        "iso": "HU",
        "value": "8",
        "label": "Debrecen"
    },
    {
        "iso": "HU",
        "value": "9",
        "label": "Dunaujvaros"
    },
    {
        "iso": "HU",
        "value": "10",
        "label": "Eger"
    },
    {
        "iso": "HU",
        "value": "11",
        "label": "Fejer"
    },
    {
        "iso": "HU",
        "value": "12",
        "label": "Gyor"
    },
    {
        "iso": "HU",
        "value": "13",
        "label": "Gyor-Moson-Sopron"
    },
    {
        "iso": "HU",
        "value": "14",
        "label": "Hajdu-Bihar"
    },
    {
        "iso": "HU",
        "value": "15",
        "label": "Heves"
    },
    {
        "iso": "HU",
        "value": "16",
        "label": "Hodmezovasarhely"
    },
    {
        "iso": "HU",
        "value": "17",
        "label": "Jasz-Nagykun-Szolnok"
    },
    {
        "iso": "HU",
        "value": "18",
        "label": "Kaposvar"
    },
    {
        "iso": "HU",
        "value": "19",
        "label": "Kecskemet"
    },
    {
        "iso": "HU",
        "value": "20",
        "label": "Komarom-Esztergom"
    },
    {
        "iso": "HU",
        "value": "21",
        "label": "Miskolc"
    },
    {
        "iso": "HU",
        "value": "22",
        "label": "Nagykanizsa"
    },
    {
        "iso": "HU",
        "value": "23",
        "label": "Nograd"
    },
    {
        "iso": "HU",
        "value": "24",
        "label": "Nyiregyhaza"
    },
    {
        "iso": "HU",
        "value": "25",
        "label": "Pecs"
    },
    {
        "iso": "HU",
        "value": "26",
        "label": "Pest"
    },
    {
        "iso": "HU",
        "value": "27",
        "label": "Somogy"
    },
    {
        "iso": "HU",
        "value": "28",
        "label": "Sopron"
    },
    {
        "iso": "HU",
        "value": "29",
        "label": "Szabolcs-Szat.-Bereg"
    },
    {
        "iso": "HU",
        "value": "30",
        "label": "Szeged"
    },
    {
        "iso": "HU",
        "value": "31",
        "label": "Szekesfehervar"
    },
    {
        "iso": "HU",
        "value": "32",
        "label": "Szolnok"
    },
    {
        "iso": "HU",
        "value": "33",
        "label": "Szombathely"
    },
    {
        "iso": "HU",
        "value": "34",
        "label": "Tatabanya"
    },
    {
        "iso": "HU",
        "value": "35",
        "label": "Tolna"
    },
    {
        "iso": "HU",
        "value": "36",
        "label": "Vas"
    },
    {
        "iso": "HU",
        "value": "37",
        "label": "Veszprem (OBSOLETE)"
    },
    {
        "iso": "HU",
        "value": "38",
        "label": "Zala"
    },
    {
        "iso": "HU",
        "value": "39",
        "label": "Zalaegerszeg"
    },
    {
        "iso": "ID",
        "value": "1",
        "label": "DKI Jakarta"
    },
    {
        "iso": "ID",
        "value": "2",
        "label": "Jawa Barat West Java"
    },
    {
        "iso": "ID",
        "value": "3",
        "label": "Jawa Tengah Central"
    },
    {
        "iso": "ID",
        "value": "4",
        "label": "Jawa Timur East Java"
    },
    {
        "iso": "ID",
        "value": "5",
        "label": "DI Yogyakarta Yogyak"
    },
    {
        "iso": "ID",
        "value": "6",
        "label": "DI Aceh"
    },
    {
        "iso": "ID",
        "value": "7",
        "label": "Sumatera Utara North"
    },
    {
        "iso": "ID",
        "value": "8",
        "label": "Sumatera Barat West"
    },
    {
        "iso": "ID",
        "value": "9",
        "label": "Riau Riau"
    },
    {
        "iso": "ID",
        "value": "10",
        "label": "Jambi Jambi"
    },
    {
        "iso": "ID",
        "value": "11",
        "label": "Sumatera Selatan Sou"
    },
    {
        "iso": "ID",
        "value": "12",
        "label": "Bengkulu Bengkulu"
    },
    {
        "iso": "ID",
        "value": "13",
        "label": "Lampung Lampung"
    },
    {
        "iso": "ID",
        "value": "14",
        "label": "Kalimantan Selatan S"
    },
    {
        "iso": "ID",
        "value": "15",
        "label": "Kalimantan Barat Wes"
    },
    {
        "iso": "ID",
        "value": "16",
        "label": "Kalimantan Tengah Ce"
    },
    {
        "iso": "ID",
        "value": "17",
        "label": "Kalimantan Timur Eas"
    },
    {
        "iso": "ID",
        "value": "18",
        "label": "Sulawesi Selatan Sou"
    },
    {
        "iso": "ID",
        "value": "19",
        "label": "Sulawesi Tenggara So"
    },
    {
        "iso": "ID",
        "value": "20",
        "label": "Sulawesi Tengah Cent"
    },
    {
        "iso": "ID",
        "value": "21",
        "label": "Sulawesi Utara North"
    },
    {
        "iso": "ID",
        "value": "22",
        "label": "Bali Bali"
    },
    {
        "iso": "ID",
        "value": "23",
        "label": "Nusa Tenggara Barat"
    },
    {
        "iso": "ID",
        "value": "24",
        "label": "Nusa Tenggara Timur"
    },
    {
        "iso": "ID",
        "value": "25",
        "label": "Maluku Maluku"
    },
    {
        "iso": "ID",
        "value": "26",
        "label": "Irian Jaya Irian Jay"
    },
    {
        "iso": "ID",
        "value": "27",
        "label": "Timor Timur East Tim"
    },
    {
        "iso": "ID",
        "value": "Z28",
        "label": "Bangka-Belitung"
    },
    {
        "iso": "ID",
        "value": "Z29",
        "label": "Banten"
    },
    {
        "iso": "ID",
        "value": "Z30",
        "label": "Gorontalo"
    },
    {
        "iso": "ID",
        "value": "Z31",
        "label": "North Maluku"
    },
    {
        "iso": "ID",
        "value": "Z32",
        "label": "Papua"
    },
    {
        "iso": "ID",
        "value": "Z33",
        "label": "Riau islands"
    },
    {
        "iso": "ID",
        "value": "Z34",
        "label": "West Papua"
    },
    {
        "iso": "IE",
        "value": "CK",
        "label": "Cork"
    },
    {
        "iso": "IE",
        "value": "CL",
        "label": "Clare"
    },
    {
        "iso": "IE",
        "value": "CV",
        "label": "Cavan"
    },
    {
        "iso": "IE",
        "value": "CW",
        "label": "Carlow"
    },
    {
        "iso": "IE",
        "value": "DB",
        "label": "Dublin"
    },
    {
        "iso": "IE",
        "value": "DG",
        "label": "Donegal"
    },
    {
        "iso": "IE",
        "value": "GW",
        "label": "Galway"
    },
    {
        "iso": "IE",
        "value": "KD",
        "label": "Kildare"
    },
    {
        "iso": "IE",
        "value": "KK",
        "label": "Kilkenny"
    },
    {
        "iso": "IE",
        "value": "KY",
        "label": "Kerry"
    },
    {
        "iso": "IE",
        "value": "LF",
        "label": "Longford"
    },
    {
        "iso": "IE",
        "value": "LI",
        "label": "Limerick"
    },
    {
        "iso": "IE",
        "value": "LM",
        "label": "Leitrim"
    },
    {
        "iso": "IE",
        "value": "LS",
        "label": "Laois"
    },
    {
        "iso": "IE",
        "value": "LT",
        "label": "Louth"
    },
    {
        "iso": "IE",
        "value": "MH",
        "label": "Monaghan"
    },
    {
        "iso": "IE",
        "value": "MT",
        "label": "Meath"
    },
    {
        "iso": "IE",
        "value": "MY",
        "label": "Mayo"
    },
    {
        "iso": "IE",
        "value": "OF",
        "label": "Offaly"
    },
    {
        "iso": "IE",
        "value": "RC",
        "label": "Rosscommon"
    },
    {
        "iso": "IE",
        "value": "SG",
        "label": "Sligo"
    },
    {
        "iso": "IE",
        "value": "TP",
        "label": "Tipperary"
    },
    {
        "iso": "IE",
        "value": "WF",
        "label": "Waterford"
    },
    {
        "iso": "IE",
        "value": "WK",
        "label": "Wicklow"
    },
    {
        "iso": "IE",
        "value": "WM",
        "label": "Westmeath"
    },
    {
        "iso": "IE",
        "value": "WX",
        "label": "Wexford"
    },
    {
        "iso": "IE",
        "value": "Z1",
        "label": "Antrim"
    },
    {
        "iso": "IE",
        "value": "Z2",
        "label": "Derry"
    },
    {
        "iso": "IE",
        "value": "Z3",
        "label": "Down"
    },
    {
        "iso": "IE",
        "value": "Z4",
        "label": "Fermanagh"
    },
    {
        "iso": "IE",
        "value": "Z5",
        "label": "Armagh"
    },
    {
        "iso": "IE",
        "value": "Z6",
        "label": "Tyrone"
    },
    {
        "iso": "IL",
        "value": "1",
        "label": "Central"
    },
    {
        "iso": "IL",
        "value": "2",
        "label": "Haifa"
    },
    {
        "iso": "IL",
        "value": "3",
        "label": "Jerusalem"
    },
    {
        "iso": "IL",
        "value": "4",
        "label": "Northern"
    },
    {
        "iso": "IL",
        "value": "5",
        "label": "Southern"
    },
    {
        "iso": "IL",
        "value": "6",
        "label": "Tel Aviv"
    },
    {
        "iso": "IN",
        "value": "1",
        "label": "Andhra Pradesh"
    },
    {
        "iso": "IN",
        "value": "2",
        "label": "Arunachal Pradesh"
    },
    {
        "iso": "IN",
        "value": "3",
        "label": "Assam"
    },
    {
        "iso": "IN",
        "value": "4",
        "label": "Bihar"
    },
    {
        "iso": "IN",
        "value": "5",
        "label": "Goa"
    },
    {
        "iso": "IN",
        "value": "6",
        "label": "Gujarat"
    },
    {
        "iso": "IN",
        "value": "7",
        "label": "Haryana"
    },
    {
        "iso": "IN",
        "value": "8",
        "label": "Himachal Pradesh"
    },
    {
        "iso": "IN",
        "value": "9",
        "label": "Jammu and Kashmir"
    },
    {
        "iso": "IN",
        "value": "10",
        "label": "Karnataka"
    },
    {
        "iso": "IN",
        "value": "11",
        "label": "Kerala"
    },
    {
        "iso": "IN",
        "value": "12",
        "label": "Madhya Pradesh"
    },
    {
        "iso": "IN",
        "value": "13",
        "label": "Maharashtra"
    },
    {
        "iso": "IN",
        "value": "14",
        "label": "Manipur"
    },
    {
        "iso": "IN",
        "value": "15",
        "label": "Meghalaya"
    },
    {
        "iso": "IN",
        "value": "16",
        "label": "Mizoram"
    },
    {
        "iso": "IN",
        "value": "17",
        "label": "Nagaland"
    },
    {
        "iso": "IN",
        "value": "18",
        "label": "Orissa"
    },
    {
        "iso": "IN",
        "value": "19",
        "label": "Punjab"
    },
    {
        "iso": "IN",
        "value": "20",
        "label": "Rajasthan"
    },
    {
        "iso": "IN",
        "value": "21",
        "label": "Sikkim"
    },
    {
        "iso": "IN",
        "value": "22",
        "label": "Tamil Nadu"
    },
    {
        "iso": "IN",
        "value": "23",
        "label": "Tripura"
    },
    {
        "iso": "IN",
        "value": "24",
        "label": "Uttar Pradesh"
    },
    {
        "iso": "IN",
        "value": "25",
        "label": "West Bengal"
    },
    {
        "iso": "IN",
        "value": "26",
        "label": "Andaman and Nico.In."
    },
    {
        "iso": "IN",
        "value": "27",
        "label": "Chandigarh"
    },
    {
        "iso": "IN",
        "value": "28",
        "label": "DadraNagHavDamanDiu"
    },
    {
        "iso": "IN",
        "value": "29",
        "label": "(obsolete)"
    },
    {
        "iso": "IN",
        "value": "30",
        "label": "Delhi"
    },
    {
        "iso": "IN",
        "value": "31",
        "label": "Lakshadweep"
    },
    {
        "iso": "IN",
        "value": "32",
        "label": "Puducherry (Pondic.)"
    },
    {
        "iso": "IN",
        "value": "33",
        "label": "Chhattisgarh"
    },
    {
        "iso": "IN",
        "value": "34",
        "label": "Jharkhand"
    },
    {
        "iso": "IN",
        "value": "35",
        "label": "Uttarakhand"
    },
    {
        "iso": "IN",
        "value": "36",
        "label": "Telangana"
    },
    {
        "iso": "IN",
        "value": "37",
        "label": "Other Territory"
    },
    {
        "iso": "IN",
        "value": "38",
        "label": "Ladakh"
    },
    {
        "iso": "IT",
        "value": "AG",
        "label": "Agriento"
    },
    {
        "iso": "IT",
        "value": "AL",
        "label": "Alessandria"
    },
    {
        "iso": "IT",
        "value": "AN",
        "label": "Ancona"
    },
    {
        "iso": "IT",
        "value": "AO",
        "label": "(obsolete) Aosta"
    },
    {
        "iso": "IT",
        "value": "AP",
        "label": "Ascoli Piceno"
    },
    {
        "iso": "IT",
        "value": "AQ",
        "label": "L'Aquila"
    },
    {
        "iso": "IT",
        "value": "AR",
        "label": "Arezzo"
    },
    {
        "iso": "IT",
        "value": "AT",
        "label": "Asti"
    },
    {
        "iso": "IT",
        "value": "AV",
        "label": "Avellino"
    },
    {
        "iso": "IT",
        "value": "BA",
        "label": "Bari"
    },
    {
        "iso": "IT",
        "value": "BG",
        "label": "Bergamo"
    },
    {
        "iso": "IT",
        "value": "BI",
        "label": "Biella"
    },
    {
        "iso": "IT",
        "value": "BL",
        "label": "Belluno"
    },
    {
        "iso": "IT",
        "value": "BN",
        "label": "Benevento"
    },
    {
        "iso": "IT",
        "value": "BO",
        "label": "Bologna"
    },
    {
        "iso": "IT",
        "value": "BR",
        "label": "Brindisi"
    },
    {
        "iso": "IT",
        "value": "BS",
        "label": "Brescia"
    },
    {
        "iso": "IT",
        "value": "BZ",
        "label": "Bolzano"
    },
    {
        "iso": "IT",
        "value": "CA",
        "label": "Cagliari"
    },
    {
        "iso": "IT",
        "value": "CB",
        "label": "Campobasso"
    },
    {
        "iso": "IT",
        "value": "CE",
        "label": "Caserta"
    },
    {
        "iso": "IT",
        "value": "CH",
        "label": "Chieti"
    },
    {
        "iso": "IT",
        "value": "CL",
        "label": "Caltanisetta"
    },
    {
        "iso": "IT",
        "value": "CN",
        "label": "Cuneo"
    },
    {
        "iso": "IT",
        "value": "CO",
        "label": "Como"
    },
    {
        "iso": "IT",
        "value": "CR",
        "label": "Cremona"
    },
    {
        "iso": "IT",
        "value": "CS",
        "label": "Cosenza"
    },
    {
        "iso": "IT",
        "value": "CT",
        "label": "Catania"
    },
    {
        "iso": "IT",
        "value": "CZ",
        "label": "Catanzaro"
    },
    {
        "iso": "IT",
        "value": "EN",
        "label": "Enna"
    },
    {
        "iso": "IT",
        "value": "FC",
        "label": "ForlÃ¬-Cesena"
    },
    {
        "iso": "IT",
        "value": "FE",
        "label": "Ferrara"
    },
    {
        "iso": "IT",
        "value": "FG",
        "label": "Foggia"
    },
    {
        "iso": "IT",
        "value": "FI",
        "label": "Firenze"
    },
    {
        "iso": "IT",
        "value": "FM",
        "label": "Fermo"
    },
    {
        "iso": "IT",
        "value": "FR",
        "label": "Frosinone"
    },
    {
        "iso": "IT",
        "value": "GE",
        "label": "Genova"
    },
    {
        "iso": "IT",
        "value": "GO",
        "label": "Gorizia"
    },
    {
        "iso": "IT",
        "value": "GR",
        "label": "Grosseto"
    },
    {
        "iso": "IT",
        "value": "IM",
        "label": "Imperia"
    },
    {
        "iso": "IT",
        "value": "IS",
        "label": "Isernia"
    },
    {
        "iso": "IT",
        "value": "KR",
        "label": "Crotone"
    },
    {
        "iso": "IT",
        "value": "LC",
        "label": "Lecco"
    },
    {
        "iso": "IT",
        "value": "LE",
        "label": "Lecce"
    },
    {
        "iso": "IT",
        "value": "LI",
        "label": "Livorno"
    },
    {
        "iso": "IT",
        "value": "LO",
        "label": "Lodi"
    },
    {
        "iso": "IT",
        "value": "LT",
        "label": "Latina"
    },
    {
        "iso": "IT",
        "value": "LU",
        "label": "Lucca"
    },
    {
        "iso": "IT",
        "value": "MB",
        "label": "Monza e Brianza"
    },
    {
        "iso": "IT",
        "value": "MC",
        "label": "Macerata"
    },
    {
        "iso": "IT",
        "value": "ME",
        "label": "Messina"
    },
    {
        "iso": "IT",
        "value": "MI",
        "label": "Milan"
    },
    {
        "iso": "IT",
        "value": "MN",
        "label": "Mantova"
    },
    {
        "iso": "IT",
        "value": "MO",
        "label": "Modena"
    },
    {
        "iso": "IT",
        "value": "MS",
        "label": "Massa Carrara"
    },
    {
        "iso": "IT",
        "value": "MT",
        "label": "Matera"
    },
    {
        "iso": "IT",
        "value": "NA",
        "label": "Naples"
    },
    {
        "iso": "IT",
        "value": "NO",
        "label": "Novara"
    },
    {
        "iso": "IT",
        "value": "NU",
        "label": "Nuoro"
    },
    {
        "iso": "IT",
        "value": "OR",
        "label": "Oristano"
    },
    {
        "iso": "IT",
        "value": "PA",
        "label": "Palermo"
    },
    {
        "iso": "IT",
        "value": "PC",
        "label": "Piacenza"
    },
    {
        "iso": "IT",
        "value": "PD",
        "label": "Padova"
    },
    {
        "iso": "IT",
        "value": "PE",
        "label": "Pescara"
    },
    {
        "iso": "IT",
        "value": "PG",
        "label": "Perugia"
    },
    {
        "iso": "IT",
        "value": "PI",
        "label": "Pisa"
    },
    {
        "iso": "IT",
        "value": "PN",
        "label": "Pordenone"
    },
    {
        "iso": "IT",
        "value": "PO",
        "label": "Prato"
    },
    {
        "iso": "IT",
        "value": "PR",
        "label": "Parma"
    },
    {
        "iso": "IT",
        "value": "PT",
        "label": "Pistoia"
    },
    {
        "iso": "IT",
        "value": "PU",
        "label": "Pesaro-Urbino"
    },
    {
        "iso": "IT",
        "value": "PV",
        "label": "Pavia"
    },
    {
        "iso": "IT",
        "value": "PZ",
        "label": "Potenza"
    },
    {
        "iso": "IT",
        "value": "RA",
        "label": "Ravenna"
    },
    {
        "iso": "IT",
        "value": "RC",
        "label": "Reggio Calabria"
    },
    {
        "iso": "IT",
        "value": "RE",
        "label": "Reggio Emilia"
    },
    {
        "iso": "IT",
        "value": "RG",
        "label": "Ragusa"
    },
    {
        "iso": "IT",
        "value": "RI",
        "label": "Rieti"
    },
    {
        "iso": "IT",
        "value": "RM",
        "label": "Rome"
    },
    {
        "iso": "IT",
        "value": "RN",
        "label": "Rimini"
    },
    {
        "iso": "IT",
        "value": "RO",
        "label": "Rovigo"
    },
    {
        "iso": "IT",
        "value": "SA",
        "label": "Salerno"
    },
    {
        "iso": "IT",
        "value": "SD",
        "label": "South Sardinia"
    },
    {
        "iso": "IT",
        "value": "SI",
        "label": "Siena"
    },
    {
        "iso": "IT",
        "value": "SO",
        "label": "Sondrio"
    },
    {
        "iso": "IT",
        "value": "SP",
        "label": "La Spezia"
    },
    {
        "iso": "IT",
        "value": "SR",
        "label": "Siracusa"
    },
    {
        "iso": "IT",
        "value": "SS",
        "label": "Sassari"
    },
    {
        "iso": "IT",
        "value": "SV",
        "label": "Savona"
    },
    {
        "iso": "IT",
        "value": "TA",
        "label": "Taranto"
    },
    {
        "iso": "IT",
        "value": "TE",
        "label": "Teramo"
    },
    {
        "iso": "IT",
        "value": "TN",
        "label": "Trento"
    },
    {
        "iso": "IT",
        "value": "TO",
        "label": "Torino"
    },
    {
        "iso": "IT",
        "value": "TP",
        "label": "Trapani"
    },
    {
        "iso": "IT",
        "value": "TR",
        "label": "Terni"
    },
    {
        "iso": "IT",
        "value": "TS",
        "label": "Trieste"
    },
    {
        "iso": "IT",
        "value": "TV",
        "label": "Treviso"
    },
    {
        "iso": "IT",
        "value": "UD",
        "label": "Udine"
    },
    {
        "iso": "IT",
        "value": "VA",
        "label": "Varese"
    },
    {
        "iso": "IT",
        "value": "VB",
        "label": "Verbano-Cusio-Ossola"
    },
    {
        "iso": "IT",
        "value": "VC",
        "label": "Vercelli"
    },
    {
        "iso": "IT",
        "value": "VE",
        "label": "Venice"
    },
    {
        "iso": "IT",
        "value": "VI",
        "label": "Vicenza"
    },
    {
        "iso": "IT",
        "value": "VR",
        "label": "Verona"
    },
    {
        "iso": "IT",
        "value": "VT",
        "label": "Viterbo"
    },
    {
        "iso": "IT",
        "value": "VV",
        "label": "Vibo Valentia"
    },
    {
        "iso": "JP",
        "value": "1",
        "label": "Hokkaido"
    },
    {
        "iso": "JP",
        "value": "2",
        "label": "Aomori"
    },
    {
        "iso": "JP",
        "value": "3",
        "label": "Iwate"
    },
    {
        "iso": "JP",
        "value": "4",
        "label": "Miyagi"
    },
    {
        "iso": "JP",
        "value": "5",
        "label": "Akita"
    },
    {
        "iso": "JP",
        "value": "6",
        "label": "Yamagata"
    },
    {
        "iso": "JP",
        "value": "7",
        "label": "Fukushima"
    },
    {
        "iso": "JP",
        "value": "8",
        "label": "Ibaraki"
    },
    {
        "iso": "JP",
        "value": "9",
        "label": "Tochigi"
    },
    {
        "iso": "JP",
        "value": "10",
        "label": "Gunma"
    },
    {
        "iso": "JP",
        "value": "11",
        "label": "Saitama"
    },
    {
        "iso": "JP",
        "value": "12",
        "label": "Chiba"
    },
    {
        "iso": "JP",
        "value": "13",
        "label": "Tokyo"
    },
    {
        "iso": "JP",
        "value": "14",
        "label": "Kanagawa"
    },
    {
        "iso": "JP",
        "value": "15",
        "label": "Niigata"
    },
    {
        "iso": "JP",
        "value": "16",
        "label": "Toyama"
    },
    {
        "iso": "JP",
        "value": "17",
        "label": "Ishikawa"
    },
    {
        "iso": "JP",
        "value": "18",
        "label": "Fukui"
    },
    {
        "iso": "JP",
        "value": "19",
        "label": "Yamanashi"
    },
    {
        "iso": "JP",
        "value": "20",
        "label": "Nagano"
    },
    {
        "iso": "JP",
        "value": "21",
        "label": "Gifu"
    },
    {
        "iso": "JP",
        "value": "22",
        "label": "Shizuoka"
    },
    {
        "iso": "JP",
        "value": "23",
        "label": "Aichi"
    },
    {
        "iso": "JP",
        "value": "24",
        "label": "Mie"
    },
    {
        "iso": "JP",
        "value": "25",
        "label": "Shiga"
    },
    {
        "iso": "JP",
        "value": "26",
        "label": "Kyoto"
    },
    {
        "iso": "JP",
        "value": "27",
        "label": "Osaka"
    },
    {
        "iso": "JP",
        "value": "28",
        "label": "Hyogo"
    },
    {
        "iso": "JP",
        "value": "29",
        "label": "Nara"
    },
    {
        "iso": "JP",
        "value": "30",
        "label": "Wakayama"
    },
    {
        "iso": "JP",
        "value": "31",
        "label": "Tottori"
    },
    {
        "iso": "JP",
        "value": "32",
        "label": "Shimane"
    },
    {
        "iso": "JP",
        "value": "33",
        "label": "Okayama"
    },
    {
        "iso": "JP",
        "value": "34",
        "label": "Hiroshima"
    },
    {
        "iso": "JP",
        "value": "35",
        "label": "Yamaguchi"
    },
    {
        "iso": "JP",
        "value": "36",
        "label": "Tokushima"
    },
    {
        "iso": "JP",
        "value": "37",
        "label": "Kagawa"
    },
    {
        "iso": "JP",
        "value": "38",
        "label": "Ehime"
    },
    {
        "iso": "JP",
        "value": "39",
        "label": "Kochi"
    },
    {
        "iso": "JP",
        "value": "40",
        "label": "Fukuoka"
    },
    {
        "iso": "JP",
        "value": "41",
        "label": "Saga"
    },
    {
        "iso": "JP",
        "value": "42",
        "label": "Nagasaki"
    },
    {
        "iso": "JP",
        "value": "43",
        "label": "Kumamoto"
    },
    {
        "iso": "JP",
        "value": "44",
        "label": "Oita"
    },
    {
        "iso": "JP",
        "value": "45",
        "label": "Miyazaki"
    },
    {
        "iso": "JP",
        "value": "46",
        "label": "Kagoshima"
    },
    {
        "iso": "JP",
        "value": "47",
        "label": "Okinawa"
    },
    {
        "iso": "KR",
        "value": "1",
        "label": "Jeju"
    },
    {
        "iso": "KR",
        "value": "2",
        "label": "Jeolla buk do"
    },
    {
        "iso": "KR",
        "value": "3",
        "label": "Jeolla nam do"
    },
    {
        "iso": "KR",
        "value": "4",
        "label": "Chungcheong buk do"
    },
    {
        "iso": "KR",
        "value": "5",
        "label": "Chungcheong nam do"
    },
    {
        "iso": "KR",
        "value": "6",
        "label": "Incheon"
    },
    {
        "iso": "KR",
        "value": "7",
        "label": "Gangwon do"
    },
    {
        "iso": "KR",
        "value": "8",
        "label": "Gwangju"
    },
    {
        "iso": "KR",
        "value": "9",
        "label": "Gyeonggi do"
    },
    {
        "iso": "KR",
        "value": "10",
        "label": "Gyeongsang buk do"
    },
    {
        "iso": "KR",
        "value": "11",
        "label": "Gyeonsang nam do"
    },
    {
        "iso": "KR",
        "value": "12",
        "label": "Busan"
    },
    {
        "iso": "KR",
        "value": "13",
        "label": "Seoul"
    },
    {
        "iso": "KR",
        "value": "14",
        "label": "Daegu"
    },
    {
        "iso": "KR",
        "value": "15",
        "label": "Daejeon"
    },
    {
        "iso": "KZ",
        "value": "0",
        "label": "Almatynskaia"
    },
    {
        "iso": "KZ",
        "value": "1",
        "label": "Kostanaiskaia"
    },
    {
        "iso": "KZ",
        "value": "10",
        "label": "Vostochno-Kazakhstan"
    },
    {
        "iso": "KZ",
        "value": "11",
        "label": "Gambilskaia"
    },
    {
        "iso": "KZ",
        "value": "12",
        "label": "Kyzilordinskaia"
    },
    {
        "iso": "KZ",
        "value": "2",
        "label": "Severo-Kazakhstansk"
    },
    {
        "iso": "KZ",
        "value": "3",
        "label": "Pavlodarskaia"
    },
    {
        "iso": "KZ",
        "value": "4",
        "label": "Akmolinskaia"
    },
    {
        "iso": "KZ",
        "value": "5",
        "label": "Aktubinskaia"
    },
    {
        "iso": "KZ",
        "value": "6",
        "label": "Atyrauskaia"
    },
    {
        "iso": "KZ",
        "value": "7",
        "label": "Zapadno-Kazakhst"
    },
    {
        "iso": "KZ",
        "value": "8",
        "label": "Mangystayskaia"
    },
    {
        "iso": "KZ",
        "value": "9",
        "label": "Karagandinskaia"
    },
    {
        "iso": "LT",
        "value": "AL",
        "label": "Distrikt Alytus"
    },
    {
        "iso": "LT",
        "value": "KL",
        "label": "Distrikt KlaipÄ—da"
    },
    {
        "iso": "LT",
        "value": "KU",
        "label": "Distrikt Kaunas"
    },
    {
        "iso": "LT",
        "value": "MR",
        "label": "Distrikt MarijampolÄ—"
    },
    {
        "iso": "LT",
        "value": "PN",
        "label": "Distrikt PanevÄ—Å¾ys"
    },
    {
        "iso": "LT",
        "value": "SA",
        "label": "Distrikt Siauliai"
    },
    {
        "iso": "LT",
        "value": "TA",
        "label": "Distrikt TauragÄ—"
    },
    {
        "iso": "LT",
        "value": "TE",
        "label": "Distrikt TelÅ¡iai"
    },
    {
        "iso": "LT",
        "value": "UT",
        "label": "Distrikt Utena"
    },
    {
        "iso": "LT",
        "value": "VL",
        "label": "Distrikt Vilnius"
    },
    {
        "iso": "LV",
        "value": "1",
        "label": "Aglonas novads"
    },
    {
        "iso": "LV",
        "value": "2",
        "label": "Aizkraukles novads"
    },
    {
        "iso": "LV",
        "value": "3",
        "label": "Aizputes novads"
    },
    {
        "iso": "LV",
        "value": "4",
        "label": "AknÄ«stes novads"
    },
    {
        "iso": "LV",
        "value": "5",
        "label": "Alojas novads"
    },
    {
        "iso": "LV",
        "value": "6",
        "label": "Alsungas novads"
    },
    {
        "iso": "LV",
        "value": "7",
        "label": "AlÅ«ksnes novads"
    },
    {
        "iso": "LV",
        "value": "8",
        "label": "Amatas novads"
    },
    {
        "iso": "LV",
        "value": "9",
        "label": "Apes novads"
    },
    {
        "iso": "LV",
        "value": "10",
        "label": "Auces novads"
    },
    {
        "iso": "LV",
        "value": "11",
        "label": "Ä€daÅ¾u novads"
    },
    {
        "iso": "LV",
        "value": "12",
        "label": "BabÄ«tes novads"
    },
    {
        "iso": "LV",
        "value": "13",
        "label": "Baldones novads"
    },
    {
        "iso": "LV",
        "value": "14",
        "label": "Baltinavas novads"
    },
    {
        "iso": "LV",
        "value": "15",
        "label": "Balvu novads"
    },
    {
        "iso": "LV",
        "value": "16",
        "label": "Bauskas novads"
    },
    {
        "iso": "LV",
        "value": "17",
        "label": "BeverÄ«nas novads"
    },
    {
        "iso": "LV",
        "value": "18",
        "label": "BrocÄ“nu novads"
    },
    {
        "iso": "LV",
        "value": "19",
        "label": "Burtnieku novads"
    },
    {
        "iso": "LV",
        "value": "20",
        "label": "Carnikavas novads"
    },
    {
        "iso": "LV",
        "value": "21",
        "label": "Cesvaines novads"
    },
    {
        "iso": "LV",
        "value": "22",
        "label": "CÄ“su novads"
    },
    {
        "iso": "LV",
        "value": "23",
        "label": "Ciblas novads"
    },
    {
        "iso": "LV",
        "value": "24",
        "label": "Dagdas novads"
    },
    {
        "iso": "LV",
        "value": "25",
        "label": "Daugavpils novads"
    },
    {
        "iso": "LV",
        "value": "26",
        "label": "Dobeles novads"
    },
    {
        "iso": "LV",
        "value": "27",
        "label": "Dundagas novads"
    },
    {
        "iso": "LV",
        "value": "28",
        "label": "Durbes novads"
    },
    {
        "iso": "LV",
        "value": "29",
        "label": "Engures novads"
    },
    {
        "iso": "LV",
        "value": "30",
        "label": "Ä’rgÄ¼u novads"
    },
    {
        "iso": "LV",
        "value": "31",
        "label": "Garkalnes novads"
    },
    {
        "iso": "LV",
        "value": "32",
        "label": "GrobiÅ†as novads"
    },
    {
        "iso": "LV",
        "value": "33",
        "label": "Gulbenes novads"
    },
    {
        "iso": "LV",
        "value": "34",
        "label": "Iecavas novads"
    },
    {
        "iso": "LV",
        "value": "35",
        "label": "IkÅ¡Ä·iles novads"
    },
    {
        "iso": "LV",
        "value": "36",
        "label": "IlÅ«kstes novads"
    },
    {
        "iso": "LV",
        "value": "37",
        "label": "InÄukalna novads"
    },
    {
        "iso": "LV",
        "value": "38",
        "label": "Jaunjelgavas novads"
    },
    {
        "iso": "LV",
        "value": "39",
        "label": "Jaunpiebalgas novads"
    },
    {
        "iso": "LV",
        "value": "40",
        "label": "Jaunpils novads"
    },
    {
        "iso": "LV",
        "value": "41",
        "label": "Jelgavas novads"
    },
    {
        "iso": "LV",
        "value": "42",
        "label": "JÄ“kabpils novads"
    },
    {
        "iso": "LV",
        "value": "43",
        "label": "Kandavas novads"
    },
    {
        "iso": "LV",
        "value": "44",
        "label": "KÄrsavas novads"
    },
    {
        "iso": "LV",
        "value": "45",
        "label": "KocÄ“nu novads"
    },
    {
        "iso": "LV",
        "value": "46",
        "label": "Kokneses novads"
    },
    {
        "iso": "LV",
        "value": "47",
        "label": "KrÄslavas novads"
    },
    {
        "iso": "LV",
        "value": "48",
        "label": "Krimuldas novads"
    },
    {
        "iso": "LV",
        "value": "49",
        "label": "Krustpils novads"
    },
    {
        "iso": "LV",
        "value": "50",
        "label": "KuldÄ«gas novads"
    },
    {
        "iso": "LV",
        "value": "51",
        "label": "Ä¶eguma novads"
    },
    {
        "iso": "LV",
        "value": "52",
        "label": "Ä¶ekavas novads"
    },
    {
        "iso": "LV",
        "value": "53",
        "label": "LielvÄrdes novads"
    },
    {
        "iso": "LV",
        "value": "54",
        "label": "LimbaÅ¾u novads"
    },
    {
        "iso": "LV",
        "value": "55",
        "label": "LÄ«gatnes novads"
    },
    {
        "iso": "LV",
        "value": "56",
        "label": "LÄ«vÄnu novads"
    },
    {
        "iso": "LV",
        "value": "57",
        "label": "LubÄnas novads"
    },
    {
        "iso": "LV",
        "value": "58",
        "label": "Ludzas novads"
    },
    {
        "iso": "LV",
        "value": "59",
        "label": "Madonas novads"
    },
    {
        "iso": "LV",
        "value": "60",
        "label": "Mazsalacas novads"
    },
    {
        "iso": "LV",
        "value": "61",
        "label": "MÄlpils novads"
    },
    {
        "iso": "LV",
        "value": "62",
        "label": "MÄrupes novads"
    },
    {
        "iso": "LV",
        "value": "63",
        "label": "MÄ“rsraga novads"
    },
    {
        "iso": "LV",
        "value": "64",
        "label": "NaukÅ¡Ä“nu novads"
    },
    {
        "iso": "LV",
        "value": "65",
        "label": "Neretas novads"
    },
    {
        "iso": "LV",
        "value": "66",
        "label": "NÄ«cas novads"
    },
    {
        "iso": "LV",
        "value": "67",
        "label": "Ogres novads"
    },
    {
        "iso": "LV",
        "value": "68",
        "label": "Olaines novads"
    },
    {
        "iso": "LV",
        "value": "69",
        "label": "Ozolnieku novads"
    },
    {
        "iso": "LV",
        "value": "70",
        "label": "PÄrgaujas novads"
    },
    {
        "iso": "LV",
        "value": "71",
        "label": "PÄvilostas novads"
    },
    {
        "iso": "LV",
        "value": "72",
        "label": "PÄ¼aviÅ†u novads"
    },
    {
        "iso": "LV",
        "value": "73",
        "label": "PreiÄ¼u novads"
    },
    {
        "iso": "LV",
        "value": "74",
        "label": "Priekules novads"
    },
    {
        "iso": "LV",
        "value": "75",
        "label": "PriekuÄ¼u novads"
    },
    {
        "iso": "LV",
        "value": "76",
        "label": "Raunas novads"
    },
    {
        "iso": "LV",
        "value": "77",
        "label": "RÄ“zeknes novads"
    },
    {
        "iso": "LV",
        "value": "78",
        "label": "RiebiÅ†u novads"
    },
    {
        "iso": "LV",
        "value": "79",
        "label": "Rojas novads"
    },
    {
        "iso": "LV",
        "value": "80",
        "label": "RopaÅ¾u novads"
    },
    {
        "iso": "LV",
        "value": "81",
        "label": "Rucavas novads"
    },
    {
        "iso": "LV",
        "value": "82",
        "label": "RugÄju novads"
    },
    {
        "iso": "LV",
        "value": "83",
        "label": "RundÄles novads"
    },
    {
        "iso": "LV",
        "value": "84",
        "label": "RÅ«jienas novads"
    },
    {
        "iso": "LV",
        "value": "85",
        "label": "Salas novads"
    },
    {
        "iso": "LV",
        "value": "86",
        "label": "SalacgrÄ«vas novads"
    },
    {
        "iso": "LV",
        "value": "87",
        "label": "Salaspils novads"
    },
    {
        "iso": "LV",
        "value": "88",
        "label": "Saldus novads"
    },
    {
        "iso": "LV",
        "value": "89",
        "label": "Saulkrastu novads"
    },
    {
        "iso": "LV",
        "value": "90",
        "label": "SÄ“jas novads"
    },
    {
        "iso": "LV",
        "value": "91",
        "label": "Siguldas novads"
    },
    {
        "iso": "LV",
        "value": "92",
        "label": "SkrÄ«veru novads"
    },
    {
        "iso": "LV",
        "value": "93",
        "label": "Skrundas novads"
    },
    {
        "iso": "LV",
        "value": "94",
        "label": "Smiltenes novads"
    },
    {
        "iso": "LV",
        "value": "95",
        "label": "StopiÅ†u novads"
    },
    {
        "iso": "LV",
        "value": "96",
        "label": "StrenÄu novads"
    },
    {
        "iso": "LV",
        "value": "97",
        "label": "Talsu novads"
    },
    {
        "iso": "LV",
        "value": "98",
        "label": "TÄ“rvetes novads"
    },
    {
        "iso": "LV",
        "value": "99",
        "label": "Tukuma novads"
    },
    {
        "iso": "LV",
        "value": "100",
        "label": "VaiÅ†odes novads"
    },
    {
        "iso": "LV",
        "value": "101",
        "label": "Valkas novads"
    },
    {
        "iso": "LV",
        "value": "102",
        "label": "VarakÄ¼Änu novads"
    },
    {
        "iso": "LV",
        "value": "103",
        "label": "VÄrkavas novads"
    },
    {
        "iso": "LV",
        "value": "104",
        "label": "Vecpiebalgas novads"
    },
    {
        "iso": "LV",
        "value": "105",
        "label": "Vecumnieku novads"
    },
    {
        "iso": "LV",
        "value": "106",
        "label": "Ventspils novads"
    },
    {
        "iso": "LV",
        "value": "107",
        "label": "ViesÄ«tes novads"
    },
    {
        "iso": "LV",
        "value": "108",
        "label": "ViÄ¼akas novads"
    },
    {
        "iso": "LV",
        "value": "109",
        "label": "ViÄ¼Änu novads"
    },
    {
        "iso": "LV",
        "value": "110",
        "label": "Zilupes novads"
    },
    {
        "iso": "LV",
        "value": "DGV",
        "label": "Daugavpils"
    },
    {
        "iso": "LV",
        "value": "JEL",
        "label": "Jelgava"
    },
    {
        "iso": "LV",
        "value": "JKB",
        "label": "JÄ“kabpils"
    },
    {
        "iso": "LV",
        "value": "JUR",
        "label": "JÅ«rmala"
    },
    {
        "iso": "LV",
        "value": "LPX",
        "label": "LiepÄja"
    },
    {
        "iso": "LV",
        "value": "REZ",
        "label": "RÄ“zekne"
    },
    {
        "iso": "LV",
        "value": "RIX",
        "label": "RÄ«ga"
    },
    {
        "iso": "LV",
        "value": "VEN",
        "label": "Ventspils"
    },
    {
        "iso": "LV",
        "value": "VMR",
        "label": "Valmiera"
    },
    {
        "iso": "ME",
        "value": "24",
        "label": "Tuzi"
    },
    {
        "iso": "MX",
        "value": "AGS",
        "label": "Aguascalientes"
    },
    {
        "iso": "MX",
        "value": "BC",
        "label": "Baja California"
    },
    {
        "iso": "MX",
        "value": "BCS",
        "label": "Baja California S"
    },
    {
        "iso": "MX",
        "value": "CHI",
        "label": "Chihuahua"
    },
    {
        "iso": "MX",
        "value": "CHS",
        "label": "Chiapas"
    },
    {
        "iso": "MX",
        "value": "CMP",
        "label": "Campeche"
    },
    {
        "iso": "MX",
        "value": "CMX",
        "label": "Ciudad de Mexico"
    },
    {
        "iso": "MX",
        "value": "COA",
        "label": "Coahuila de Zaragoza"
    },
    {
        "iso": "MX",
        "value": "COL",
        "label": "Colima"
    },
    {
        "iso": "MX",
        "value": "DGO",
        "label": "Durango"
    },
    {
        "iso": "MX",
        "value": "GRO",
        "label": "Guerrero"
    },
    {
        "iso": "MX",
        "value": "GTO",
        "label": "Guanajuato"
    },
    {
        "iso": "MX",
        "value": "HGO",
        "label": "Hidalgo"
    },
    {
        "iso": "MX",
        "value": "JAL",
        "label": "Jalisco"
    },
    {
        "iso": "MX",
        "value": "MCH",
        "label": "MichoacÃ¡n de Ocampo"
    },
    {
        "iso": "MX",
        "value": "MEX",
        "label": "Estado de Mexico"
    },
    {
        "iso": "MX",
        "value": "MOR",
        "label": "Morelos"
    },
    {
        "iso": "MX",
        "value": "NAY",
        "label": "Nayarit"
    },
    {
        "iso": "MX",
        "value": "NL",
        "label": "Nuevo Leon"
    },
    {
        "iso": "MX",
        "value": "OAX",
        "label": "Oaxaca"
    },
    {
        "iso": "MX",
        "value": "PUE",
        "label": "Puebla"
    },
    {
        "iso": "MX",
        "value": "QR",
        "label": "Quintana Roo"
    },
    {
        "iso": "MX",
        "value": "QRO",
        "label": "Queretaro"
    },
    {
        "iso": "MX",
        "value": "SIN",
        "label": "Sinaloa"
    },
    {
        "iso": "MX",
        "value": "SLP",
        "label": "San Luis Potosi"
    },
    {
        "iso": "MX",
        "value": "SON",
        "label": "Sonora"
    },
    {
        "iso": "MX",
        "value": "TAB",
        "label": "Tabasco"
    },
    {
        "iso": "MX",
        "value": "TLX",
        "label": "Tlaxcala"
    },
    {
        "iso": "MX",
        "value": "TMS",
        "label": "Tamaulipas"
    },
    {
        "iso": "MX",
        "value": "VER",
        "label": "Veracruz de Ignacio"
    },
    {
        "iso": "MX",
        "value": "YUC",
        "label": "Yucatan"
    },
    {
        "iso": "MX",
        "value": "ZAC",
        "label": "Zacatecas"
    },
    {
        "iso": "MY",
        "value": "JOH",
        "label": "Johor"
    },
    {
        "iso": "MY",
        "value": "KED",
        "label": "Kedah"
    },
    {
        "iso": "MY",
        "value": "KEL",
        "label": "Kelantan"
    },
    {
        "iso": "MY",
        "value": "KUL",
        "label": "Kuala Lumpur"
    },
    {
        "iso": "MY",
        "value": "LAB",
        "label": "Labuan"
    },
    {
        "iso": "MY",
        "value": "MEL",
        "label": "Melaka"
    },
    {
        "iso": "MY",
        "value": "PAH",
        "label": "Pahang"
    },
    {
        "iso": "MY",
        "value": "PEL",
        "label": "Perlis"
    },
    {
        "iso": "MY",
        "value": "PER",
        "label": "Perak"
    },
    {
        "iso": "MY",
        "value": "PIN",
        "label": "Pulau Pinang"
    },
    {
        "iso": "MY",
        "value": "SAB",
        "label": "Sabah"
    },
    {
        "iso": "MY",
        "value": "SAR",
        "label": "Sarawak"
    },
    {
        "iso": "MY",
        "value": "SEL",
        "label": "Selangor"
    },
    {
        "iso": "MY",
        "value": "SER",
        "label": "Negeri Sembilan"
    },
    {
        "iso": "MY",
        "value": "TRE",
        "label": "Terengganu"
    },
    {
        "iso": "MY",
        "value": "ZPS",
        "label": "Wil. Persekutuan"
    },
    {
        "iso": "NL",
        "value": "1",
        "label": "Drenthe"
    },
    {
        "iso": "NL",
        "value": "2",
        "label": "Flevoland"
    },
    {
        "iso": "NL",
        "value": "3",
        "label": "Friesland"
    },
    {
        "iso": "NL",
        "value": "4",
        "label": "Gelderland"
    },
    {
        "iso": "NL",
        "value": "5",
        "label": "Groningen"
    },
    {
        "iso": "NL",
        "value": "6",
        "label": "Limburg"
    },
    {
        "iso": "NL",
        "value": "7",
        "label": "Noord-Brabant"
    },
    {
        "iso": "NL",
        "value": "8",
        "label": "Noord-Holland"
    },
    {
        "iso": "NL",
        "value": "9",
        "label": "Overijssel"
    },
    {
        "iso": "NL",
        "value": "10",
        "label": "Utrecht"
    },
    {
        "iso": "NL",
        "value": "11",
        "label": "Zeeland"
    },
    {
        "iso": "NL",
        "value": "12",
        "label": "Zuid-Holland"
    },
    {
        "iso": "NO",
        "value": "1",
        "label": "ostfold Fylke"
    },
    {
        "iso": "NO",
        "value": "2",
        "label": "Akershus Fylke"
    },
    {
        "iso": "NO",
        "value": "3",
        "label": "Oslo"
    },
    {
        "iso": "NO",
        "value": "4",
        "label": "Hedmark Fylke"
    },
    {
        "iso": "NO",
        "value": "5",
        "label": "Oppland Fylke"
    },
    {
        "iso": "NO",
        "value": "6",
        "label": "Buskerud Fylke"
    },
    {
        "iso": "NO",
        "value": "7",
        "label": "Vestfold Fylke"
    },
    {
        "iso": "NO",
        "value": "8",
        "label": "Telemark Fylke"
    },
    {
        "iso": "NO",
        "value": "9",
        "label": "Aust-AgderFylke"
    },
    {
        "iso": "NO",
        "value": "10",
        "label": "Vest-AgderFylke"
    },
    {
        "iso": "NO",
        "value": "11",
        "label": "Rogaland"
    },
    {
        "iso": "NO",
        "value": "12",
        "label": "Hordaland Fylke"
    },
    {
        "iso": "NO",
        "value": "14",
        "label": "SognOgFjordane F."
    },
    {
        "iso": "NO",
        "value": "15",
        "label": "MÃ¸re og Romsdal"
    },
    {
        "iso": "NO",
        "value": "18",
        "label": "Nordland"
    },
    {
        "iso": "NO",
        "value": "19",
        "label": "Troms Fylke"
    },
    {
        "iso": "NO",
        "value": "20",
        "label": "Finnmark Fylke"
    },
    {
        "iso": "NO",
        "value": "50",
        "label": "TrÃ¸ndelag"
    },
    {
        "iso": "NO",
        "value": "Z16",
        "label": "Sor-Trondelag County"
    },
    {
        "iso": "NO",
        "value": "Z17",
        "label": "Nord-Trondelag Cnty"
    },
    {
        "iso": "NZ",
        "value": "AKL",
        "label": "Auckland"
    },
    {
        "iso": "NZ",
        "value": "BOP",
        "label": "Bay of Plenty"
    },
    {
        "iso": "NZ",
        "value": "CAN",
        "label": "Canterbury"
    },
    {
        "iso": "NZ",
        "value": "HAB",
        "label": "Hawke's Bay"
    },
    {
        "iso": "NZ",
        "value": "MAN",
        "label": "Manawatu-Wanganui"
    },
    {
        "iso": "NZ",
        "value": "NTL",
        "label": "Northland"
    },
    {
        "iso": "NZ",
        "value": "OTA",
        "label": "Otago"
    },
    {
        "iso": "NZ",
        "value": "STL",
        "label": "Southland"
    },
    {
        "iso": "NZ",
        "value": "TAR",
        "label": "Taranaki"
    },
    {
        "iso": "NZ",
        "value": "WAI",
        "label": "Waikato"
    },
    {
        "iso": "NZ",
        "value": "WEC",
        "label": "West Coast"
    },
    {
        "iso": "NZ",
        "value": "WLG",
        "label": "Wellington"
    },
    {
        "iso": "PE",
        "value": "1",
        "label": "Tumbes"
    },
    {
        "iso": "PE",
        "value": "2",
        "label": "Piura"
    },
    {
        "iso": "PE",
        "value": "3",
        "label": "Lambayeque"
    },
    {
        "iso": "PE",
        "value": "4",
        "label": "La Libertad"
    },
    {
        "iso": "PE",
        "value": "5",
        "label": "Ancash"
    },
    {
        "iso": "PE",
        "value": "6",
        "label": "Lima"
    },
    {
        "iso": "PE",
        "value": "7",
        "label": "Ica"
    },
    {
        "iso": "PE",
        "value": "8",
        "label": "Arequipa"
    },
    {
        "iso": "PE",
        "value": "9",
        "label": "Moquegua"
    },
    {
        "iso": "PE",
        "value": "10",
        "label": "Tacna"
    },
    {
        "iso": "PE",
        "value": "11",
        "label": "Amazon"
    },
    {
        "iso": "PE",
        "value": "12",
        "label": "Cajamarca"
    },
    {
        "iso": "PE",
        "value": "13",
        "label": "San Martin"
    },
    {
        "iso": "PE",
        "value": "14",
        "label": "Huanuco"
    },
    {
        "iso": "PE",
        "value": "15",
        "label": "Pasco"
    },
    {
        "iso": "PE",
        "value": "16",
        "label": "Junin"
    },
    {
        "iso": "PE",
        "value": "17",
        "label": "Huancavelica"
    },
    {
        "iso": "PE",
        "value": "18",
        "label": "Ayacucho"
    },
    {
        "iso": "PE",
        "value": "19",
        "label": "Apurimac"
    },
    {
        "iso": "PE",
        "value": "20",
        "label": "Cuzco"
    },
    {
        "iso": "PE",
        "value": "21",
        "label": "Puno"
    },
    {
        "iso": "PE",
        "value": "22",
        "label": "Loreto"
    },
    {
        "iso": "PE",
        "value": "23",
        "label": "Ucayali"
    },
    {
        "iso": "PE",
        "value": "24",
        "label": "Madre de Dios"
    },
    {
        "iso": "PE",
        "value": "25",
        "label": "Callao"
    },
    {
        "iso": "PH",
        "value": "2",
        "label": "Cagayan Valley"
    },
    {
        "iso": "PH",
        "value": "41",
        "label": "Mimaropa"
    },
    {
        "iso": "PH",
        "value": "Z01",
        "label": "Abra"
    },
    {
        "iso": "PH",
        "value": "Z02",
        "label": "Agusan del Norte"
    },
    {
        "iso": "PH",
        "value": "Z03",
        "label": "Agusan del Sur"
    },
    {
        "iso": "PH",
        "value": "Z04",
        "label": "Aklan"
    },
    {
        "iso": "PH",
        "value": "Z05",
        "label": "Albay"
    },
    {
        "iso": "PH",
        "value": "Z06",
        "label": "Antique"
    },
    {
        "iso": "PH",
        "value": "Z07",
        "label": "Apayao"
    },
    {
        "iso": "PH",
        "value": "Z08",
        "label": "Aurora"
    },
    {
        "iso": "PH",
        "value": "Z09",
        "label": "Basilan"
    },
    {
        "iso": "PH",
        "value": "Z10",
        "label": "Bataan"
    },
    {
        "iso": "PH",
        "value": "Z11",
        "label": "Batanes"
    },
    {
        "iso": "PH",
        "value": "Z12",
        "label": "Batangas"
    },
    {
        "iso": "PH",
        "value": "Z13",
        "label": "Benguet"
    },
    {
        "iso": "PH",
        "value": "Z14",
        "label": "Biliran"
    },
    {
        "iso": "PH",
        "value": "Z15",
        "label": "Bohol"
    },
    {
        "iso": "PH",
        "value": "Z16",
        "label": "Bukidnon"
    },
    {
        "iso": "PH",
        "value": "Z17",
        "label": "Bulacan"
    },
    {
        "iso": "PH",
        "value": "Z19",
        "label": "Caloocan City"
    },
    {
        "iso": "PH",
        "value": "Z20",
        "label": "Camarines Norte"
    },
    {
        "iso": "PH",
        "value": "Z21",
        "label": "Camarines Sur"
    },
    {
        "iso": "PH",
        "value": "Z22",
        "label": "Camiguin"
    },
    {
        "iso": "PH",
        "value": "Z23",
        "label": "Capiz"
    },
    {
        "iso": "PH",
        "value": "Z24",
        "label": "Catanduanes"
    },
    {
        "iso": "PH",
        "value": "Z25",
        "label": "Cavite"
    },
    {
        "iso": "PH",
        "value": "Z26",
        "label": "Cebu"
    },
    {
        "iso": "PH",
        "value": "Z27",
        "label": "Compostela Valley"
    },
    {
        "iso": "PH",
        "value": "Z28",
        "label": "Cotabato"
    },
    {
        "iso": "PH",
        "value": "Z29",
        "label": "Davao del Norte"
    },
    {
        "iso": "PH",
        "value": "Z30",
        "label": "Davao del Sur"
    },
    {
        "iso": "PH",
        "value": "Z31",
        "label": "Davao Oriental"
    },
    {
        "iso": "PH",
        "value": "Z32",
        "label": "Dinagat Islands"
    },
    {
        "iso": "PH",
        "value": "Z33",
        "label": "Eastern Samar"
    },
    {
        "iso": "PH",
        "value": "Z34",
        "label": "General Santos City"
    },
    {
        "iso": "PH",
        "value": "Z35",
        "label": "Guimaras"
    },
    {
        "iso": "PH",
        "value": "Z36",
        "label": "Ifugao"
    },
    {
        "iso": "PH",
        "value": "Z37",
        "label": "Ilocos Norte"
    },
    {
        "iso": "PH",
        "value": "Z38",
        "label": "Ilocos Sur"
    },
    {
        "iso": "PH",
        "value": "Z39",
        "label": "Iloilo"
    },
    {
        "iso": "PH",
        "value": "Z40",
        "label": "Isabela"
    },
    {
        "iso": "PH",
        "value": "Z42",
        "label": "La Union"
    },
    {
        "iso": "PH",
        "value": "Z43",
        "label": "Laguna"
    },
    {
        "iso": "PH",
        "value": "Z44",
        "label": "Lanao del Norte"
    },
    {
        "iso": "PH",
        "value": "Z45",
        "label": "Lanao del Sur"
    },
    {
        "iso": "PH",
        "value": "Z46",
        "label": "Las PiÃ±as City"
    },
    {
        "iso": "PH",
        "value": "Z47",
        "label": "Leyte"
    },
    {
        "iso": "PH",
        "value": "Z48",
        "label": "Maguindanao"
    },
    {
        "iso": "PH",
        "value": "Z49",
        "label": "Makati City"
    },
    {
        "iso": "PH",
        "value": "Z50",
        "label": "Malabon City"
    },
    {
        "iso": "PH",
        "value": "Z51",
        "label": "Mandaluyong City"
    },
    {
        "iso": "PH",
        "value": "Z52",
        "label": "Manila"
    },
    {
        "iso": "PH",
        "value": "Z53",
        "label": "Marikina City"
    },
    {
        "iso": "PH",
        "value": "Z54",
        "label": "Marinduque"
    },
    {
        "iso": "PH",
        "value": "Z55",
        "label": "Masbate"
    },
    {
        "iso": "PH",
        "value": "Z56",
        "label": "Misamis Occidental"
    },
    {
        "iso": "PH",
        "value": "Z57",
        "label": "Misamis Oriental"
    },
    {
        "iso": "PH",
        "value": "Z58",
        "label": "Mountain Province"
    },
    {
        "iso": "PH",
        "value": "Z59",
        "label": "Muntinlupa City"
    },
    {
        "iso": "PH",
        "value": "Z60",
        "label": "Navotas City"
    },
    {
        "iso": "PH",
        "value": "Z61",
        "label": "Negros Occidental"
    },
    {
        "iso": "PH",
        "value": "Z62",
        "label": "Negros Oriental"
    },
    {
        "iso": "PH",
        "value": "Z63",
        "label": "Northern Samar"
    },
    {
        "iso": "PH",
        "value": "Z64",
        "label": "Nueva Ecija"
    },
    {
        "iso": "PH",
        "value": "Z65",
        "label": "Nueva Vizcaya"
    },
    {
        "iso": "PH",
        "value": "Z66",
        "label": "Occidental Mindoro"
    },
    {
        "iso": "PH",
        "value": "Z67",
        "label": "Oriental Mindoro"
    },
    {
        "iso": "PH",
        "value": "Z68",
        "label": "Palawan"
    },
    {
        "iso": "PH",
        "value": "Z69",
        "label": "Pampanga"
    },
    {
        "iso": "PH",
        "value": "Z70",
        "label": "Pangasinan"
    },
    {
        "iso": "PH",
        "value": "Z71",
        "label": "ParaÃ±aque City"
    },
    {
        "iso": "PH",
        "value": "Z72",
        "label": "Pasay City"
    },
    {
        "iso": "PH",
        "value": "Z73",
        "label": "Pasig City"
    },
    {
        "iso": "PH",
        "value": "Z74",
        "label": "Pateros"
    },
    {
        "iso": "PH",
        "value": "Z75",
        "label": "Quezon"
    },
    {
        "iso": "PH",
        "value": "Z76",
        "label": "Quezon City"
    },
    {
        "iso": "PH",
        "value": "Z77",
        "label": "Quirino"
    },
    {
        "iso": "PH",
        "value": "Z78",
        "label": "Rizal"
    },
    {
        "iso": "PH",
        "value": "Z79",
        "label": "Romblon"
    },
    {
        "iso": "PH",
        "value": "Z80",
        "label": "Samar"
    },
    {
        "iso": "PH",
        "value": "Z81",
        "label": "San Juan City"
    },
    {
        "iso": "PH",
        "value": "Z82",
        "label": "Sarangani"
    },
    {
        "iso": "PH",
        "value": "Z83",
        "label": "Shariff Kabunsuan"
    },
    {
        "iso": "PH",
        "value": "Z84",
        "label": "Siquijor"
    },
    {
        "iso": "PH",
        "value": "Z85",
        "label": "Sorsogon"
    },
    {
        "iso": "PH",
        "value": "Z86",
        "label": "South Cotabato"
    },
    {
        "iso": "PH",
        "value": "Z87",
        "label": "Southern Leyte"
    },
    {
        "iso": "PH",
        "value": "Z88",
        "label": "Sultan Kudarat"
    },
    {
        "iso": "PH",
        "value": "Z89",
        "label": "Sulu"
    },
    {
        "iso": "PH",
        "value": "Z90",
        "label": "Surigao del Norte"
    },
    {
        "iso": "PH",
        "value": "Z91",
        "label": "Surigao del Sur"
    },
    {
        "iso": "PH",
        "value": "Z92",
        "label": "Taguig City"
    },
    {
        "iso": "PH",
        "value": "Z93",
        "label": "Tarlac"
    },
    {
        "iso": "PH",
        "value": "Z94",
        "label": "Tawi-Tawi"
    },
    {
        "iso": "PH",
        "value": "Z95",
        "label": "Valenzuela City"
    },
    {
        "iso": "PH",
        "value": "Z96",
        "label": "Zambales"
    },
    {
        "iso": "PH",
        "value": "Z97",
        "label": "Zamboanga del Norte"
    },
    {
        "iso": "PH",
        "value": "Z98",
        "label": "Zamboanga del Sur"
    },
    {
        "iso": "PH",
        "value": "Z99",
        "label": "Zamboanga Sibugay"
    },
    {
        "iso": "PL",
        "value": "DSL",
        "label": "Dolnoslaskie"
    },
    {
        "iso": "PL",
        "value": "K-P",
        "label": "Kujawsko-Pomorskie"
    },
    {
        "iso": "PL",
        "value": "LBL",
        "label": "Lubelskie"
    },
    {
        "iso": "PL",
        "value": "LBS",
        "label": "Lubuskie"
    },
    {
        "iso": "PL",
        "value": "LDZ",
        "label": "Lodzkie"
    },
    {
        "iso": "PL",
        "value": "MAL",
        "label": "Malopolskie"
    },
    {
        "iso": "PL",
        "value": "MAZ",
        "label": "Mazowieckie"
    },
    {
        "iso": "PL",
        "value": "OPO",
        "label": "Opolskie"
    },
    {
        "iso": "PL",
        "value": "PDK",
        "label": "Podkarpackie"
    },
    {
        "iso": "PL",
        "value": "PDL",
        "label": "Podlaskie"
    },
    {
        "iso": "PL",
        "value": "POM",
        "label": "Pomorskie"
    },
    {
        "iso": "PL",
        "value": "SLS",
        "label": "Slaskie"
    },
    {
        "iso": "PL",
        "value": "SWK",
        "label": "Swietokrzyskie"
    },
    {
        "iso": "PL",
        "value": "W-M",
        "label": "Warminsko-mazurskie"
    },
    {
        "iso": "PL",
        "value": "WLK",
        "label": "Wielkopolskie"
    },
    {
        "iso": "PL",
        "value": "Z-P",
        "label": "Zachodnio-Pomorskie"
    },
    {
        "iso": "PR",
        "value": "ZGN",
        "label": "Guaynabo"
    },
    {
        "iso": "PT",
        "value": "10",
        "label": "Minho-Lima"
    },
    {
        "iso": "PT",
        "value": "11",
        "label": "Cavado"
    },
    {
        "iso": "PT",
        "value": "12",
        "label": "Ave"
    },
    {
        "iso": "PT",
        "value": "13",
        "label": "Grande Porto"
    },
    {
        "iso": "PT",
        "value": "14",
        "label": "TÃ¢mega"
    },
    {
        "iso": "PT",
        "value": "15",
        "label": "Entre Douro e Vouga"
    },
    {
        "iso": "PT",
        "value": "16",
        "label": "Douro"
    },
    {
        "iso": "PT",
        "value": "17",
        "label": "Alto Tras-os-Montes"
    },
    {
        "iso": "PT",
        "value": "20",
        "label": "Baixo Vouga"
    },
    {
        "iso": "PT",
        "value": "21",
        "label": "Baixo Mondego"
    },
    {
        "iso": "PT",
        "value": "22",
        "label": "Pinhal Litoral"
    },
    {
        "iso": "PT",
        "value": "23",
        "label": "Pinhal Interior N."
    },
    {
        "iso": "PT",
        "value": "24",
        "label": "Pinhal Interior Sul"
    },
    {
        "iso": "PT",
        "value": "25",
        "label": "Dao-Lafoes"
    },
    {
        "iso": "PT",
        "value": "26",
        "label": "Serra da Estrela"
    },
    {
        "iso": "PT",
        "value": "27",
        "label": "Beira Interior Norte"
    },
    {
        "iso": "PT",
        "value": "28",
        "label": "Beira Interior Sul"
    },
    {
        "iso": "PT",
        "value": "29",
        "label": "Cova da Beira"
    },
    {
        "iso": "PT",
        "value": "30",
        "label": "Oeste"
    },
    {
        "iso": "PT",
        "value": "31",
        "label": "Grande Lisboa"
    },
    {
        "iso": "PT",
        "value": "32",
        "label": "Peninsula de Setubal"
    },
    {
        "iso": "PT",
        "value": "33",
        "label": "Medio Tejo"
    },
    {
        "iso": "PT",
        "value": "34",
        "label": "Leziria do Tejo"
    },
    {
        "iso": "PT",
        "value": "40",
        "label": "Alentejo Litoral"
    },
    {
        "iso": "PT",
        "value": "41",
        "label": "Alto Alentejo"
    },
    {
        "iso": "PT",
        "value": "42",
        "label": "Alentejo Central"
    },
    {
        "iso": "PT",
        "value": "43",
        "label": "Baixo Alentejo"
    },
    {
        "iso": "PT",
        "value": "50",
        "label": "Algarve"
    },
    {
        "iso": "PT",
        "value": "60",
        "label": "Reg. Aut. dos AÃ§ores"
    },
    {
        "iso": "PT",
        "value": "70",
        "label": "Reg. Aut. da Madeira"
    },
    {
        "iso": "RO",
        "value": "1",
        "label": "Alba"
    },
    {
        "iso": "RO",
        "value": "2",
        "label": "Arad"
    },
    {
        "iso": "RO",
        "value": "3",
        "label": "Arges"
    },
    {
        "iso": "RO",
        "value": "4",
        "label": "Bacau"
    },
    {
        "iso": "RO",
        "value": "5",
        "label": "Bihor"
    },
    {
        "iso": "RO",
        "value": "6",
        "label": "Bistrita-Nasaud"
    },
    {
        "iso": "RO",
        "value": "7",
        "label": "Botosani"
    },
    {
        "iso": "RO",
        "value": "8",
        "label": "Braila"
    },
    {
        "iso": "RO",
        "value": "9",
        "label": "Brasov"
    },
    {
        "iso": "RO",
        "value": "10",
        "label": "Bucuresti"
    },
    {
        "iso": "RO",
        "value": "11",
        "label": "Buzau"
    },
    {
        "iso": "RO",
        "value": "12",
        "label": "Calarasi"
    },
    {
        "iso": "RO",
        "value": "13",
        "label": "Caras-Severin"
    },
    {
        "iso": "RO",
        "value": "14",
        "label": "Cluj"
    },
    {
        "iso": "RO",
        "value": "15",
        "label": "Constanta"
    },
    {
        "iso": "RO",
        "value": "16",
        "label": "Covasna"
    },
    {
        "iso": "RO",
        "value": "17",
        "label": "Dambovita"
    },
    {
        "iso": "RO",
        "value": "18",
        "label": "Dolj"
    },
    {
        "iso": "RO",
        "value": "19",
        "label": "Galati"
    },
    {
        "iso": "RO",
        "value": "20",
        "label": "Gorj"
    },
    {
        "iso": "RO",
        "value": "21",
        "label": "Giurgiu"
    },
    {
        "iso": "RO",
        "value": "22",
        "label": "Harghita"
    },
    {
        "iso": "RO",
        "value": "23",
        "label": "Hunedoara"
    },
    {
        "iso": "RO",
        "value": "24",
        "label": "Ialomita"
    },
    {
        "iso": "RO",
        "value": "25",
        "label": "Iasi"
    },
    {
        "iso": "RO",
        "value": "26",
        "label": "Maramures"
    },
    {
        "iso": "RO",
        "value": "27",
        "label": "Mehedinti"
    },
    {
        "iso": "RO",
        "value": "28",
        "label": "Mures"
    },
    {
        "iso": "RO",
        "value": "29",
        "label": "Neamt"
    },
    {
        "iso": "RO",
        "value": "30",
        "label": "Olt"
    },
    {
        "iso": "RO",
        "value": "31",
        "label": "Prahova"
    },
    {
        "iso": "RO",
        "value": "32",
        "label": "Salaj"
    },
    {
        "iso": "RO",
        "value": "33",
        "label": "Satu Mare"
    },
    {
        "iso": "RO",
        "value": "34",
        "label": "Sibiu"
    },
    {
        "iso": "RO",
        "value": "35",
        "label": "Suceava"
    },
    {
        "iso": "RO",
        "value": "36",
        "label": "Teleorman"
    },
    {
        "iso": "RO",
        "value": "37",
        "label": "Timis"
    },
    {
        "iso": "RO",
        "value": "38",
        "label": "Tulcea"
    },
    {
        "iso": "RO",
        "value": "39",
        "label": "Vaslui"
    },
    {
        "iso": "RO",
        "value": "40",
        "label": "Valcea"
    },
    {
        "iso": "RO",
        "value": "41",
        "label": "Vrancea"
    },
    {
        "iso": "RU",
        "value": "1",
        "label": "Adigeja Republic"
    },
    {
        "iso": "RU",
        "value": "2",
        "label": "Highlands-Altay Rep."
    },
    {
        "iso": "RU",
        "value": "3",
        "label": "Republ.of Bashkortos"
    },
    {
        "iso": "RU",
        "value": "4",
        "label": "Buryat Republic"
    },
    {
        "iso": "RU",
        "value": "5",
        "label": "Dagestan Republic"
    },
    {
        "iso": "RU",
        "value": "6",
        "label": "Ingushetija Republic"
    },
    {
        "iso": "RU",
        "value": "7",
        "label": "Kabardino-Balkar.Rep"
    },
    {
        "iso": "RU",
        "value": "8",
        "label": "Kalmyk Republic"
    },
    {
        "iso": "RU",
        "value": "9",
        "label": "Karach.-Cherkessk Re"
    },
    {
        "iso": "RU",
        "value": "10",
        "label": "Karelian Republic"
    },
    {
        "iso": "RU",
        "value": "11",
        "label": "Komi Republic"
    },
    {
        "iso": "RU",
        "value": "12",
        "label": "Marijskaya Republic"
    },
    {
        "iso": "RU",
        "value": "13",
        "label": "Mordovian Republic"
    },
    {
        "iso": "RU",
        "value": "14",
        "label": "Yakutiya-Saha Rrepub"
    },
    {
        "iso": "RU",
        "value": "15",
        "label": "North-Osetiya Republ"
    },
    {
        "iso": "RU",
        "value": "16",
        "label": "Tatarstan Republic"
    },
    {
        "iso": "RU",
        "value": "17",
        "label": "Tuva Republic"
    },
    {
        "iso": "RU",
        "value": "18",
        "label": "The Udmurt Republic"
    },
    {
        "iso": "RU",
        "value": "19",
        "label": "Chakassky Republic"
    },
    {
        "iso": "RU",
        "value": "20",
        "label": "Chechenskaya Republ."
    },
    {
        "iso": "RU",
        "value": "21",
        "label": "Chuvash Republic"
    },
    {
        "iso": "RU",
        "value": "22",
        "label": "Altay Territory"
    },
    {
        "iso": "RU",
        "value": "23",
        "label": "Krasnodar Territory"
    },
    {
        "iso": "RU",
        "value": "24",
        "label": "Krasnoyarsk Territor"
    },
    {
        "iso": "RU",
        "value": "25",
        "label": "Primorye Territory"
    },
    {
        "iso": "RU",
        "value": "26",
        "label": "Stavropol Territory"
    },
    {
        "iso": "RU",
        "value": "27",
        "label": "Khabarovsk Territory"
    },
    {
        "iso": "RU",
        "value": "28",
        "label": "The Amur Area"
    },
    {
        "iso": "RU",
        "value": "29",
        "label": "The Arkhangelsk Area"
    },
    {
        "iso": "RU",
        "value": "30",
        "label": "The Astrakhan Area"
    },
    {
        "iso": "RU",
        "value": "31",
        "label": "The Belgorod Area"
    },
    {
        "iso": "RU",
        "value": "32",
        "label": "The Bryansk Area"
    },
    {
        "iso": "RU",
        "value": "33",
        "label": "The Vladimir Area"
    },
    {
        "iso": "RU",
        "value": "34",
        "label": "The Volgograd Area"
    },
    {
        "iso": "RU",
        "value": "35",
        "label": "The Vologda Area"
    },
    {
        "iso": "RU",
        "value": "36",
        "label": "The Voronezh Area"
    },
    {
        "iso": "RU",
        "value": "37",
        "label": "The Ivanovo Area"
    },
    {
        "iso": "RU",
        "value": "38",
        "label": "The Irkutsk Area"
    },
    {
        "iso": "RU",
        "value": "39",
        "label": "The Kaliningrad Area"
    },
    {
        "iso": "RU",
        "value": "40",
        "label": "The Kaluga Area"
    },
    {
        "iso": "RU",
        "value": "41",
        "label": "The Kamchatka Area"
    },
    {
        "iso": "RU",
        "value": "42",
        "label": "The Kemerovo Area"
    },
    {
        "iso": "RU",
        "value": "43",
        "label": "The Kirov Area"
    },
    {
        "iso": "RU",
        "value": "44",
        "label": "The Kostroma Area"
    },
    {
        "iso": "RU",
        "value": "45",
        "label": "The Kurgan Area"
    },
    {
        "iso": "RU",
        "value": "46",
        "label": "The Kursk Area"
    },
    {
        "iso": "RU",
        "value": "47",
        "label": "The Leningrad Area"
    },
    {
        "iso": "RU",
        "value": "48",
        "label": "The Lipetsk Area"
    },
    {
        "iso": "RU",
        "value": "49",
        "label": "The Magadan Area"
    },
    {
        "iso": "RU",
        "value": "50",
        "label": "The Moscow Area"
    },
    {
        "iso": "RU",
        "value": "51",
        "label": "The Murmansk Area"
    },
    {
        "iso": "RU",
        "value": "52",
        "label": "The Nizhniy Novgorod"
    },
    {
        "iso": "RU",
        "value": "53",
        "label": "The Novgorod Area"
    },
    {
        "iso": "RU",
        "value": "54",
        "label": "The Novosibirsk Area"
    },
    {
        "iso": "RU",
        "value": "55",
        "label": "The Omsk Area"
    },
    {
        "iso": "RU",
        "value": "56",
        "label": "The Orenburg Area"
    },
    {
        "iso": "RU",
        "value": "57",
        "label": "The Oryol Area"
    },
    {
        "iso": "RU",
        "value": "58",
        "label": "The Penza Area"
    },
    {
        "iso": "RU",
        "value": "59",
        "label": "The Perm Area"
    },
    {
        "iso": "RU",
        "value": "60",
        "label": "The Pskov Area"
    },
    {
        "iso": "RU",
        "value": "61",
        "label": "The Rostov Area"
    },
    {
        "iso": "RU",
        "value": "62",
        "label": "The Ryazan Area"
    },
    {
        "iso": "RU",
        "value": "63",
        "label": "The Samara Area"
    },
    {
        "iso": "RU",
        "value": "64",
        "label": "The Saratov Area"
    },
    {
        "iso": "RU",
        "value": "65",
        "label": "The Sakhalin Area"
    },
    {
        "iso": "RU",
        "value": "66",
        "label": "The Sverdlovsk Area"
    },
    {
        "iso": "RU",
        "value": "67",
        "label": "The Smolensk Area"
    },
    {
        "iso": "RU",
        "value": "68",
        "label": "The Tambov Area"
    },
    {
        "iso": "RU",
        "value": "69",
        "label": "The Tver Area"
    },
    {
        "iso": "RU",
        "value": "70",
        "label": "The Tomsk Area"
    },
    {
        "iso": "RU",
        "value": "71",
        "label": "The Tula Area"
    },
    {
        "iso": "RU",
        "value": "72",
        "label": "The Tyumen Area"
    },
    {
        "iso": "RU",
        "value": "73",
        "label": "The Ulyanovsk Area"
    },
    {
        "iso": "RU",
        "value": "74",
        "label": "The Chelyabinsk Area"
    },
    {
        "iso": "RU",
        "value": "75",
        "label": "The Chita Area"
    },
    {
        "iso": "RU",
        "value": "76",
        "label": "The Yaroslavl Area"
    },
    {
        "iso": "RU",
        "value": "77",
        "label": "c.Moscow"
    },
    {
        "iso": "RU",
        "value": "78",
        "label": "c.St-Peterburg"
    },
    {
        "iso": "RU",
        "value": "79",
        "label": "The Jewish Auton.are"
    },
    {
        "iso": "RU",
        "value": "80",
        "label": "Aginsk Buryat Aut.di"
    },
    {
        "iso": "RU",
        "value": "81",
        "label": "Komy Permjats.Aut.di"
    },
    {
        "iso": "RU",
        "value": "82",
        "label": "Korjacs Auton.distri"
    },
    {
        "iso": "RU",
        "value": "83",
        "label": "Nenekchky Auton.dist"
    },
    {
        "iso": "RU",
        "value": "84",
        "label": "The Taymir Auton.dis"
    },
    {
        "iso": "RU",
        "value": "85",
        "label": "Ust-Ordinsky Buryat"
    },
    {
        "iso": "RU",
        "value": "86",
        "label": "Chanti-Mansyjsky Aut"
    },
    {
        "iso": "RU",
        "value": "87",
        "label": "Chukotka Auton. dist"
    },
    {
        "iso": "RU",
        "value": "88",
        "label": "Evensky Auton.distri"
    },
    {
        "iso": "RU",
        "value": "89",
        "label": "Jamalo-Nenekchky Aut"
    },
    {
        "iso": "SE",
        "value": "1",
        "label": "Blekinge Lan"
    },
    {
        "iso": "SE",
        "value": "2",
        "label": "Dalarnas Lan"
    },
    {
        "iso": "SE",
        "value": "3",
        "label": "Gotlands Lan"
    },
    {
        "iso": "SE",
        "value": "4",
        "label": "Gavleborgs Lan"
    },
    {
        "iso": "SE",
        "value": "5",
        "label": "Hallands Lan"
    },
    {
        "iso": "SE",
        "value": "6",
        "label": "Jamtlands Lan"
    },
    {
        "iso": "SE",
        "value": "7",
        "label": "Jonkopings Lan"
    },
    {
        "iso": "SE",
        "value": "8",
        "label": "Kalmar Lan"
    },
    {
        "iso": "SE",
        "value": "9",
        "label": "Kronobergs Lan"
    },
    {
        "iso": "SE",
        "value": "10",
        "label": "Norrbottens Lan"
    },
    {
        "iso": "SE",
        "value": "11",
        "label": "SkAne Lan"
    },
    {
        "iso": "SE",
        "value": "12",
        "label": "Stockholms Lan"
    },
    {
        "iso": "SE",
        "value": "13",
        "label": "Sodermanlands Lan"
    },
    {
        "iso": "SE",
        "value": "14",
        "label": "Uppsala Lan"
    },
    {
        "iso": "SE",
        "value": "15",
        "label": "Varmlands Lan"
    },
    {
        "iso": "SE",
        "value": "16",
        "label": "Vasterbottens Lan"
    },
    {
        "iso": "SE",
        "value": "17",
        "label": "Vasternorrlands Lan"
    },
    {
        "iso": "SE",
        "value": "18",
        "label": "Vastmanlands Lan"
    },
    {
        "iso": "SE",
        "value": "19",
        "label": "Vastra Gotalands Lan"
    },
    {
        "iso": "SE",
        "value": "20",
        "label": "orebro Lan"
    },
    {
        "iso": "SE",
        "value": "21",
        "label": "ostergotlands Lan"
    },
    {
        "iso": "SG",
        "value": "SG",
        "label": "Singapore"
    },
    {
        "iso": "SI",
        "value": "1",
        "label": "Ajdovscina"
    },
    {
        "iso": "SI",
        "value": "2",
        "label": "Brezice"
    },
    {
        "iso": "SI",
        "value": "3",
        "label": "Celje"
    },
    {
        "iso": "SI",
        "value": "4",
        "label": "Cerknica"
    },
    {
        "iso": "SI",
        "value": "5",
        "label": "Crnomelj"
    },
    {
        "iso": "SI",
        "value": "6",
        "label": "Dravograd"
    },
    {
        "iso": "SI",
        "value": "7",
        "label": "Gornja Radgona"
    },
    {
        "iso": "SI",
        "value": "8",
        "label": "Grosuplje"
    },
    {
        "iso": "SI",
        "value": "9",
        "label": "Hrastnik Lasko"
    },
    {
        "iso": "SI",
        "value": "10",
        "label": "Idrija"
    },
    {
        "iso": "SI",
        "value": "11",
        "label": "Ilirska Bistrica"
    },
    {
        "iso": "SI",
        "value": "12",
        "label": "Izola"
    },
    {
        "iso": "SI",
        "value": "13",
        "label": "Jesenice"
    },
    {
        "iso": "SI",
        "value": "14",
        "label": "Kamnik"
    },
    {
        "iso": "SI",
        "value": "15",
        "label": "Kocevje"
    },
    {
        "iso": "SI",
        "value": "16",
        "label": "Koper"
    },
    {
        "iso": "SI",
        "value": "17",
        "label": "Kranj"
    },
    {
        "iso": "SI",
        "value": "18",
        "label": "Krsko"
    },
    {
        "iso": "SI",
        "value": "19",
        "label": "Lenart"
    },
    {
        "iso": "SI",
        "value": "20",
        "label": "Lendava"
    },
    {
        "iso": "SI",
        "value": "21",
        "label": "Litija"
    },
    {
        "iso": "SI",
        "value": "22",
        "label": "Ljubljana-Bezigrad"
    },
    {
        "iso": "SI",
        "value": "23",
        "label": "Ljubljana-Center"
    },
    {
        "iso": "SI",
        "value": "24",
        "label": "Ljubljana-Moste-Polj"
    },
    {
        "iso": "SI",
        "value": "25",
        "label": "Ljubljana-Siska"
    },
    {
        "iso": "SI",
        "value": "26",
        "label": "Ljubljana-Vic-Rudnik"
    },
    {
        "iso": "SI",
        "value": "27",
        "label": "Ljutomer"
    },
    {
        "iso": "SI",
        "value": "28",
        "label": "Logatec"
    },
    {
        "iso": "SI",
        "value": "29",
        "label": "Maribor"
    },
    {
        "iso": "SI",
        "value": "30",
        "label": "Metlika"
    },
    {
        "iso": "SI",
        "value": "31",
        "label": "Mozirje"
    },
    {
        "iso": "SI",
        "value": "32",
        "label": "Murska Sobota"
    },
    {
        "iso": "SI",
        "value": "33",
        "label": "Nova Gorica"
    },
    {
        "iso": "SI",
        "value": "34",
        "label": "Novo Mesto"
    },
    {
        "iso": "SI",
        "value": "35",
        "label": "Ormoz"
    },
    {
        "iso": "SI",
        "value": "36",
        "label": "Pesnica"
    },
    {
        "iso": "SI",
        "value": "37",
        "label": "Piran"
    },
    {
        "iso": "SI",
        "value": "38",
        "label": "Postojna"
    },
    {
        "iso": "SI",
        "value": "39",
        "label": "Ptuj"
    },
    {
        "iso": "SI",
        "value": "40",
        "label": "Radlje Ob Dravi"
    },
    {
        "iso": "SI",
        "value": "41",
        "label": "Radovljica"
    },
    {
        "iso": "SI",
        "value": "42",
        "label": "Ravne Na Koroskem"
    },
    {
        "iso": "SI",
        "value": "43",
        "label": "Ribnica"
    },
    {
        "iso": "SI",
        "value": "44",
        "label": "Ruse"
    },
    {
        "iso": "SI",
        "value": "45",
        "label": "Sentjur Pri Celju"
    },
    {
        "iso": "SI",
        "value": "46",
        "label": "Sevnica"
    },
    {
        "iso": "SI",
        "value": "47",
        "label": "Sezana"
    },
    {
        "iso": "SI",
        "value": "48",
        "label": "Skofja Loka"
    },
    {
        "iso": "SI",
        "value": "49",
        "label": "Slovenj Gradec"
    },
    {
        "iso": "SI",
        "value": "50",
        "label": "Slovenska Bistrica"
    },
    {
        "iso": "SI",
        "value": "51",
        "label": "Slovenske Konjice"
    },
    {
        "iso": "SI",
        "value": "52",
        "label": "Smarje Pri Jelsah"
    },
    {
        "iso": "SI",
        "value": "53",
        "label": "Tolmin"
    },
    {
        "iso": "SI",
        "value": "54",
        "label": "Trbovlje"
    },
    {
        "iso": "SI",
        "value": "55",
        "label": "Trebnje"
    },
    {
        "iso": "SI",
        "value": "56",
        "label": "Trzic"
    },
    {
        "iso": "SI",
        "value": "57",
        "label": "Velenje"
    },
    {
        "iso": "SI",
        "value": "58",
        "label": "Vrhnika"
    },
    {
        "iso": "SI",
        "value": "59",
        "label": "Zagorje Ob Savi"
    },
    {
        "iso": "SI",
        "value": "60",
        "label": "Zalec"
    },
    {
        "iso": "SK",
        "value": "1",
        "label": "Bratislava"
    },
    {
        "iso": "SK",
        "value": "2",
        "label": "Zapadoslovensky"
    },
    {
        "iso": "SK",
        "value": "3",
        "label": "Stredoslovensky"
    },
    {
        "iso": "SK",
        "value": "4",
        "label": "Vychodoslovensky"
    },
    {
        "iso": "TH",
        "value": "1",
        "label": "Amnat Charoen"
    },
    {
        "iso": "TH",
        "value": "2",
        "label": "Ang Thong"
    },
    {
        "iso": "TH",
        "value": "3",
        "label": "Buriram"
    },
    {
        "iso": "TH",
        "value": "4",
        "label": "Chachoengsao"
    },
    {
        "iso": "TH",
        "value": "5",
        "label": "Chai Nat"
    },
    {
        "iso": "TH",
        "value": "6",
        "label": "Chaiyaphum"
    },
    {
        "iso": "TH",
        "value": "7",
        "label": "Chanthaburi"
    },
    {
        "iso": "TH",
        "value": "8",
        "label": "Chiang Mai"
    },
    {
        "iso": "TH",
        "value": "9",
        "label": "Chiang Rai"
    },
    {
        "iso": "TH",
        "value": "10",
        "label": "Chon Buri"
    },
    {
        "iso": "TH",
        "value": "11",
        "label": "Chumphon"
    },
    {
        "iso": "TH",
        "value": "12",
        "label": "Kalasin"
    },
    {
        "iso": "TH",
        "value": "13",
        "label": "Kamphaeng Phet"
    },
    {
        "iso": "TH",
        "value": "14",
        "label": "Kanchanaburi"
    },
    {
        "iso": "TH",
        "value": "15",
        "label": "Khon Kaen"
    },
    {
        "iso": "TH",
        "value": "16",
        "label": "Krabi"
    },
    {
        "iso": "TH",
        "value": "19",
        "label": "Lampang"
    },
    {
        "iso": "TH",
        "value": "20",
        "label": "Lamphun"
    },
    {
        "iso": "TH",
        "value": "21",
        "label": "Loei"
    },
    {
        "iso": "TH",
        "value": "22",
        "label": "Lop Buri"
    },
    {
        "iso": "TH",
        "value": "23",
        "label": "Mae Hong Son"
    },
    {
        "iso": "TH",
        "value": "24",
        "label": "Maha Sarakham"
    },
    {
        "iso": "TH",
        "value": "25",
        "label": "Mukdahan"
    },
    {
        "iso": "TH",
        "value": "26",
        "label": "Nakhon Nayok"
    },
    {
        "iso": "TH",
        "value": "27",
        "label": "Nakhon Pathom"
    },
    {
        "iso": "TH",
        "value": "28",
        "label": "Nakhon Phanom"
    },
    {
        "iso": "TH",
        "value": "29",
        "label": "Nakhon Ratchasima"
    },
    {
        "iso": "TH",
        "value": "30",
        "label": "Nakhon Sawan"
    },
    {
        "iso": "TH",
        "value": "31",
        "label": "Nakhon Si Thammarat"
    },
    {
        "iso": "TH",
        "value": "32",
        "label": "Nan"
    },
    {
        "iso": "TH",
        "value": "33",
        "label": "Narathiwat"
    },
    {
        "iso": "TH",
        "value": "34",
        "label": "Nong Bua Lamphu"
    },
    {
        "iso": "TH",
        "value": "35",
        "label": "Nong Khai"
    },
    {
        "iso": "TH",
        "value": "36",
        "label": "Nonthaburi"
    },
    {
        "iso": "TH",
        "value": "37",
        "label": "Pathum Thani"
    },
    {
        "iso": "TH",
        "value": "38",
        "label": "Pattani"
    },
    {
        "iso": "TH",
        "value": "39",
        "label": "Phangnga"
    },
    {
        "iso": "TH",
        "value": "40",
        "label": "Phatthalung"
    },
    {
        "iso": "TH",
        "value": "41",
        "label": "Phayao"
    },
    {
        "iso": "TH",
        "value": "42",
        "label": "Phetchabun"
    },
    {
        "iso": "TH",
        "value": "43",
        "label": "Phetchaburi"
    },
    {
        "iso": "TH",
        "value": "44",
        "label": "Phichit"
    },
    {
        "iso": "TH",
        "value": "45",
        "label": "Phitsanulok"
    },
    {
        "iso": "TH",
        "value": "47",
        "label": "Phrae"
    },
    {
        "iso": "TH",
        "value": "48",
        "label": "Phuket"
    },
    {
        "iso": "TH",
        "value": "49",
        "label": "Prachin Buri"
    },
    {
        "iso": "TH",
        "value": "51",
        "label": "Rayong"
    },
    {
        "iso": "TH",
        "value": "52",
        "label": "Roi Et"
    },
    {
        "iso": "TH",
        "value": "53",
        "label": "Uttaradit"
    },
    {
        "iso": "TH",
        "value": "54",
        "label": "Sakon Nakhon"
    },
    {
        "iso": "TH",
        "value": "55",
        "label": "Samut Prakan"
    },
    {
        "iso": "TH",
        "value": "56",
        "label": "Saraburi"
    },
    {
        "iso": "TH",
        "value": "57",
        "label": "Sisaket"
    },
    {
        "iso": "TH",
        "value": "58",
        "label": "Sing Buri"
    },
    {
        "iso": "TH",
        "value": "59",
        "label": "Surin"
    },
    {
        "iso": "TH",
        "value": "60",
        "label": "Trat"
    },
    {
        "iso": "TH",
        "value": "61",
        "label": "Uthai Thani"
    },
    {
        "iso": "TH",
        "value": "62",
        "label": "Ubon Ratchathani"
    },
    {
        "iso": "TH",
        "value": "63",
        "label": "Tak"
    },
    {
        "iso": "TH",
        "value": "64",
        "label": "Sukhothai"
    },
    {
        "iso": "TH",
        "value": "65",
        "label": "Udon Thani"
    },
    {
        "iso": "TH",
        "value": "66",
        "label": "Sa Kaeo"
    },
    {
        "iso": "TH",
        "value": "67",
        "label": "Yasothon"
    },
    {
        "iso": "TH",
        "value": "70",
        "label": "Ratchaburi"
    },
    {
        "iso": "TH",
        "value": "72",
        "label": "Suphan Buri"
    },
    {
        "iso": "TH",
        "value": "74",
        "label": "Samut Sakhon"
    },
    {
        "iso": "TH",
        "value": "75",
        "label": "Samut Songkhram"
    },
    {
        "iso": "TH",
        "value": "77",
        "label": "Prachuap Khiri Khan"
    },
    {
        "iso": "TH",
        "value": "84",
        "label": "Surat Thani"
    },
    {
        "iso": "TH",
        "value": "85",
        "label": "Ranong"
    },
    {
        "iso": "TH",
        "value": "90",
        "label": "Songkhla"
    },
    {
        "iso": "TH",
        "value": "91",
        "label": "Satun"
    },
    {
        "iso": "TH",
        "value": "92",
        "label": "Trang"
    },
    {
        "iso": "TH",
        "value": "95",
        "label": "Yala"
    },
    {
        "iso": "TH",
        "value": "96",
        "label": "Bueng Kan"
    },
    {
        "iso": "TH",
        "value": "Z01",
        "label": "Bangkok"
    },
    {
        "iso": "TH",
        "value": "Z04",
        "label": "Ayutthaya"
    },
    {
        "iso": "TR",
        "value": "1",
        "label": "Adana"
    },
    {
        "iso": "TR",
        "value": "2",
        "label": "Adiyaman"
    },
    {
        "iso": "TR",
        "value": "3",
        "label": "Afyon"
    },
    {
        "iso": "TR",
        "value": "4",
        "label": "Agri"
    },
    {
        "iso": "TR",
        "value": "5",
        "label": "Amasya"
    },
    {
        "iso": "TR",
        "value": "6",
        "label": "Ankara"
    },
    {
        "iso": "TR",
        "value": "7",
        "label": "Antalya"
    },
    {
        "iso": "TR",
        "value": "8",
        "label": "Artvin"
    },
    {
        "iso": "TR",
        "value": "9",
        "label": "Aydin"
    },
    {
        "iso": "TR",
        "value": "10",
        "label": "Balikesir"
    },
    {
        "iso": "TR",
        "value": "11",
        "label": "Bilecik"
    },
    {
        "iso": "TR",
        "value": "12",
        "label": "Bingol"
    },
    {
        "iso": "TR",
        "value": "13",
        "label": "Bitlis"
    },
    {
        "iso": "TR",
        "value": "14",
        "label": "Bolu"
    },
    {
        "iso": "TR",
        "value": "15",
        "label": "Burdur"
    },
    {
        "iso": "TR",
        "value": "16",
        "label": "Bursa"
    },
    {
        "iso": "TR",
        "value": "17",
        "label": "Canakkale"
    },
    {
        "iso": "TR",
        "value": "18",
        "label": "Cankiri"
    },
    {
        "iso": "TR",
        "value": "19",
        "label": "Corum"
    },
    {
        "iso": "TR",
        "value": "20",
        "label": "Denizli"
    },
    {
        "iso": "TR",
        "value": "21",
        "label": "Diyarbakir"
    },
    {
        "iso": "TR",
        "value": "22",
        "label": "Edirne"
    },
    {
        "iso": "TR",
        "value": "23",
        "label": "Elazig"
    },
    {
        "iso": "TR",
        "value": "24",
        "label": "Erzincan"
    },
    {
        "iso": "TR",
        "value": "25",
        "label": "Erzurum"
    },
    {
        "iso": "TR",
        "value": "26",
        "label": "Eskisehir"
    },
    {
        "iso": "TR",
        "value": "27",
        "label": "Gaziantep"
    },
    {
        "iso": "TR",
        "value": "28",
        "label": "Giresun"
    },
    {
        "iso": "TR",
        "value": "29",
        "label": "Gumushane"
    },
    {
        "iso": "TR",
        "value": "30",
        "label": "Hakkari"
    },
    {
        "iso": "TR",
        "value": "31",
        "label": "Hatay"
    },
    {
        "iso": "TR",
        "value": "32",
        "label": "Isparta"
    },
    {
        "iso": "TR",
        "value": "33",
        "label": "Icel"
    },
    {
        "iso": "TR",
        "value": "34",
        "label": "Istanbul"
    },
    {
        "iso": "TR",
        "value": "35",
        "label": "Izmir"
    },
    {
        "iso": "TR",
        "value": "36",
        "label": "Kars"
    },
    {
        "iso": "TR",
        "value": "37",
        "label": "Kastamonu"
    },
    {
        "iso": "TR",
        "value": "38",
        "label": "Kayseri"
    },
    {
        "iso": "TR",
        "value": "39",
        "label": "Kirklareli"
    },
    {
        "iso": "TR",
        "value": "40",
        "label": "Kirshehir"
    },
    {
        "iso": "TR",
        "value": "41",
        "label": "Kocaeli"
    },
    {
        "iso": "TR",
        "value": "42",
        "label": "Konya"
    },
    {
        "iso": "TR",
        "value": "43",
        "label": "Kutahya"
    },
    {
        "iso": "TR",
        "value": "44",
        "label": "Malatya"
    },
    {
        "iso": "TR",
        "value": "45",
        "label": "Manisa"
    },
    {
        "iso": "TR",
        "value": "46",
        "label": "K.Marash"
    },
    {
        "iso": "TR",
        "value": "47",
        "label": "Mardin"
    },
    {
        "iso": "TR",
        "value": "48",
        "label": "Mugla"
    },
    {
        "iso": "TR",
        "value": "49",
        "label": "Mush"
    },
    {
        "iso": "TR",
        "value": "50",
        "label": "Nevshehir"
    },
    {
        "iso": "TR",
        "value": "51",
        "label": "Nigde"
    },
    {
        "iso": "TR",
        "value": "52",
        "label": "Ordu"
    },
    {
        "iso": "TR",
        "value": "53",
        "label": "Rize"
    },
    {
        "iso": "TR",
        "value": "54",
        "label": "Sakarya"
    },
    {
        "iso": "TR",
        "value": "55",
        "label": "Samsun"
    },
    {
        "iso": "TR",
        "value": "56",
        "label": "Siirt"
    },
    {
        "iso": "TR",
        "value": "57",
        "label": "Sinop"
    },
    {
        "iso": "TR",
        "value": "58",
        "label": "Sivas"
    },
    {
        "iso": "TR",
        "value": "59",
        "label": "Tekirdag"
    },
    {
        "iso": "TR",
        "value": "60",
        "label": "Tokat"
    },
    {
        "iso": "TR",
        "value": "61",
        "label": "Trabzon"
    },
    {
        "iso": "TR",
        "value": "62",
        "label": "Tunceli"
    },
    {
        "iso": "TR",
        "value": "63",
        "label": "Shanliurfa"
    },
    {
        "iso": "TR",
        "value": "64",
        "label": "Ushak"
    },
    {
        "iso": "TR",
        "value": "65",
        "label": "Van"
    },
    {
        "iso": "TR",
        "value": "66",
        "label": "Yozgat"
    },
    {
        "iso": "TR",
        "value": "67",
        "label": "Zonguldak"
    },
    {
        "iso": "TR",
        "value": "68",
        "label": "Aksaray"
    },
    {
        "iso": "TR",
        "value": "69",
        "label": "Bayburt"
    },
    {
        "iso": "TR",
        "value": "70",
        "label": "Karaman"
    },
    {
        "iso": "TR",
        "value": "71",
        "label": "Kirikkale"
    },
    {
        "iso": "TR",
        "value": "72",
        "label": "Batman"
    },
    {
        "iso": "TR",
        "value": "73",
        "label": "Shirnak"
    },
    {
        "iso": "TR",
        "value": "74",
        "label": "Bartin"
    },
    {
        "iso": "TR",
        "value": "75",
        "label": "Ardahan"
    },
    {
        "iso": "TR",
        "value": "76",
        "label": "Igdir"
    },
    {
        "iso": "TR",
        "value": "77",
        "label": "Yalova"
    },
    {
        "iso": "TR",
        "value": "78",
        "label": "KarabÃ¼k"
    },
    {
        "iso": "TR",
        "value": "79",
        "label": "Kilis"
    },
    {
        "iso": "TR",
        "value": "80",
        "label": "Osmaniye"
    },
    {
        "iso": "TR",
        "value": "81",
        "label": "DÃ¼zce"
    },
    {
        "iso": "TW",
        "value": "FJN",
        "label": "Fu-chien"
    },
    {
        "iso": "TW",
        "value": "KHH",
        "label": "Kaohsiung"
    },
    {
        "iso": "TW",
        "value": "TPE",
        "label": "T'ai-pei"
    },
    {
        "iso": "TW",
        "value": "TWN",
        "label": "Taiwan"
    },
    {
        "iso": "UA",
        "value": "CHG",
        "label": "Chernigivs'ka"
    },
    {
        "iso": "UA",
        "value": "CHR",
        "label": "Cherkas'ka"
    },
    {
        "iso": "UA",
        "value": "CHV",
        "label": "Chernovits'ka"
    },
    {
        "iso": "UA",
        "value": "DNP",
        "label": "Dnipropetrovs'ka"
    },
    {
        "iso": "UA",
        "value": "DON",
        "label": "Donets'ka"
    },
    {
        "iso": "UA",
        "value": "HAR",
        "label": "Harkivs'ka"
    },
    {
        "iso": "UA",
        "value": "HML",
        "label": "Hmel'nits'ka"
    },
    {
        "iso": "UA",
        "value": "HRS",
        "label": "Hersons'ka"
    },
    {
        "iso": "UA",
        "value": "IVF",
        "label": "Ivano-Frankivs'ka"
    },
    {
        "iso": "UA",
        "value": "KIE",
        "label": "Kievs'ka"
    },
    {
        "iso": "UA",
        "value": "KIR",
        "label": "Kirovograds'ka"
    },
    {
        "iso": "UA",
        "value": "KRM",
        "label": "Respublika Krim"
    },
    {
        "iso": "UA",
        "value": "L'V",
        "label": "L'vivsbka"
    },
    {
        "iso": "UA",
        "value": "LUG",
        "label": "Lugans'ka"
    },
    {
        "iso": "UA",
        "value": "MIK",
        "label": "Mikolaivs'ka"
    },
    {
        "iso": "UA",
        "value": "M_K",
        "label": "m.Kiev"
    },
    {
        "iso": "UA",
        "value": "M_S",
        "label": "m.Sevastopil'"
    },
    {
        "iso": "UA",
        "value": "ODS",
        "label": "Odes'ka"
    },
    {
        "iso": "UA",
        "value": "POL",
        "label": "Poltavs'ka"
    },
    {
        "iso": "UA",
        "value": "RIV",
        "label": "Rivnens'ka"
    },
    {
        "iso": "UA",
        "value": "SUM",
        "label": "Sums'ka"
    },
    {
        "iso": "UA",
        "value": "TER",
        "label": "Ternopil's'ka"
    },
    {
        "iso": "UA",
        "value": "VIN",
        "label": "Vinnits'ka"
    },
    {
        "iso": "UA",
        "value": "VOL",
        "label": "Volins'ka"
    },
    {
        "iso": "UA",
        "value": "ZAK",
        "label": "Zakarpats'ka"
    },
    {
        "iso": "UA",
        "value": "ZAP",
        "label": "Zaporiz'ka"
    },
    {
        "iso": "UA",
        "value": "ZHI",
        "label": "Zhitomirs'ka"
    },
    {
        "iso": "US",
        "value": "AK",
        "label": "Alaska"
    },
    {
        "iso": "US",
        "value": "AL",
        "label": "Alabama"
    },
    {
        "iso": "US",
        "value": "AR",
        "label": "Arkansas"
    },
    {
        "iso": "US",
        "value": "AS",
        "label": "American Samoa"
    },
    {
        "iso": "US",
        "value": "AZ",
        "label": "Arizona"
    },
    {
        "iso": "US",
        "value": "CA",
        "label": "California"
    },
    {
        "iso": "US",
        "value": "CO",
        "label": "Colorado"
    },
    {
        "iso": "US",
        "value": "CT",
        "label": "Connecticut"
    },
    {
        "iso": "US",
        "value": "DC",
        "label": "District of Columbia"
    },
    {
        "iso": "US",
        "value": "DE",
        "label": "Delaware"
    },
    {
        "iso": "US",
        "value": "FL",
        "label": "Florida"
    },
    {
        "iso": "US",
        "value": "GA",
        "label": "Georgia"
    },
    {
        "iso": "US",
        "value": "GU",
        "label": "Guam"
    },
    {
        "iso": "US",
        "value": "HI",
        "label": "Hawaii"
    },
    {
        "iso": "US",
        "value": "IA",
        "label": "Iowa"
    },
    {
        "iso": "US",
        "value": "ID",
        "label": "Idaho"
    },
    {
        "iso": "US",
        "value": "IL",
        "label": "Illinois"
    },
    {
        "iso": "US",
        "value": "IN",
        "label": "Indiana"
    },
    {
        "iso": "US",
        "value": "KS",
        "label": "Kansas"
    },
    {
        "iso": "US",
        "value": "KY",
        "label": "Kentucky"
    },
    {
        "iso": "US",
        "value": "LA",
        "label": "Louisiana"
    },
    {
        "iso": "US",
        "value": "MA",
        "label": "Massachusetts"
    },
    {
        "iso": "US",
        "value": "MD",
        "label": "Maryland"
    },
    {
        "iso": "US",
        "value": "ME",
        "label": "Maine"
    },
    {
        "iso": "US",
        "value": "MI",
        "label": "Michigan"
    },
    {
        "iso": "US",
        "value": "MN",
        "label": "Minnesota"
    },
    {
        "iso": "US",
        "value": "MO",
        "label": "Missouri"
    },
    {
        "iso": "US",
        "value": "MP",
        "label": "Northern Mariana Isl"
    },
    {
        "iso": "US",
        "value": "MS",
        "label": "Mississippi"
    },
    {
        "iso": "US",
        "value": "MT",
        "label": "Montana"
    },
    {
        "iso": "US",
        "value": "NC",
        "label": "North Carolina"
    },
    {
        "iso": "US",
        "value": "ND",
        "label": "North Dakota"
    },
    {
        "iso": "US",
        "value": "NE",
        "label": "Nebraska"
    },
    {
        "iso": "US",
        "value": "NH",
        "label": "New Hampshire"
    },
    {
        "iso": "US",
        "value": "NJ",
        "label": "New Jersey"
    },
    {
        "iso": "US",
        "value": "NM",
        "label": "New Mexico"
    },
    {
        "iso": "US",
        "value": "NV",
        "label": "Nevada"
    },
    {
        "iso": "US",
        "value": "NY",
        "label": "New York"
    },
    {
        "iso": "US",
        "value": "OH",
        "label": "Ohio"
    },
    {
        "iso": "US",
        "value": "OK",
        "label": "Oklahoma"
    },
    {
        "iso": "US",
        "value": "OR",
        "label": "Oregon"
    },
    {
        "iso": "US",
        "value": "PA",
        "label": "Pennsylvania"
    },
    {
        "iso": "US",
        "value": "PR",
        "label": "Puerto Rico"
    },
    {
        "iso": "US",
        "value": "RI",
        "label": "Rhode Island"
    },
    {
        "iso": "US",
        "value": "SC",
        "label": "South Carolina"
    },
    {
        "iso": "US",
        "value": "SD",
        "label": "South Dakota"
    },
    {
        "iso": "US",
        "value": "TN",
        "label": "Tennessee"
    },
    {
        "iso": "US",
        "value": "TX",
        "label": "Texas"
    },
    {
        "iso": "US",
        "value": "UT",
        "label": "Utah"
    },
    {
        "iso": "US",
        "value": "VA",
        "label": "Virginia"
    },
    {
        "iso": "US",
        "value": "VI",
        "label": "Virgin Islands"
    },
    {
        "iso": "US",
        "value": "VT",
        "label": "Vermont"
    },
    {
        "iso": "US",
        "value": "WA",
        "label": "Washington"
    },
    {
        "iso": "US",
        "value": "WI",
        "label": "Wisconsin"
    },
    {
        "iso": "US",
        "value": "WV",
        "label": "West Virginia"
    },
    {
        "iso": "US",
        "value": "WY",
        "label": "Wyoming"
    },
    {
        "iso": "VE",
        "value": "AMA",
        "label": "Amazonas"
    },
    {
        "iso": "VE",
        "value": "ANZ",
        "label": "Anzoategui"
    },
    {
        "iso": "VE",
        "value": "APU",
        "label": "Apure"
    },
    {
        "iso": "VE",
        "value": "ARA",
        "label": "Aragua"
    },
    {
        "iso": "VE",
        "value": "BAR",
        "label": "Barinas"
    },
    {
        "iso": "VE",
        "value": "BOL",
        "label": "Bolivar"
    },
    {
        "iso": "VE",
        "value": "CAR",
        "label": "Carabobo"
    },
    {
        "iso": "VE",
        "value": "COJ",
        "label": "Cojedes"
    },
    {
        "iso": "VE",
        "value": "DA",
        "label": "Delta Amacuro"
    },
    {
        "iso": "VE",
        "value": "DF",
        "label": "Distrito Capital"
    },
    {
        "iso": "VE",
        "value": "FAL",
        "label": "Falcon"
    },
    {
        "iso": "VE",
        "value": "GUA",
        "label": "Guarico"
    },
    {
        "iso": "VE",
        "value": "LAR",
        "label": "Lara"
    },
    {
        "iso": "VE",
        "value": "MER",
        "label": "Merida"
    },
    {
        "iso": "VE",
        "value": "MIR",
        "label": "Miranda"
    },
    {
        "iso": "VE",
        "value": "MON",
        "label": "Monagas"
    },
    {
        "iso": "VE",
        "value": "NE",
        "label": "Nueva Esparta"
    },
    {
        "iso": "VE",
        "value": "POR",
        "label": "Portuguesa"
    },
    {
        "iso": "VE",
        "value": "SUC",
        "label": "Sucre"
    },
    {
        "iso": "VE",
        "value": "TAC",
        "label": "Tachira"
    },
    {
        "iso": "VE",
        "value": "TRU",
        "label": "Trujillo"
    },
    {
        "iso": "VE",
        "value": "VAR",
        "label": "La Guaira"
    },
    {
        "iso": "VE",
        "value": "YAR",
        "label": "Yaracuy"
    },
    {
        "iso": "VE",
        "value": "ZUL",
        "label": "Zulia"
    },
    {
        "iso": "ZA",
        "value": "EC",
        "label": "Eastern Cape"
    },
    {
        "iso": "ZA",
        "value": "FS",
        "label": "Free State"
    },
    {
        "iso": "ZA",
        "value": "GP",
        "label": "Gauteng"
    },
    {
        "iso": "ZA",
        "value": "KZN",
        "label": "KwaZulu-Natal"
    },
    {
        "iso": "ZA",
        "value": "MP",
        "label": "Mpumalanga"
    },
    {
        "iso": "ZA",
        "value": "NC",
        "label": "Northern Cape"
    },
    {
        "iso": "ZA",
        "value": "NP",
        "label": "No. Prov. (obsolete)"
    },
    {
        "iso": "ZA",
        "value": "NW",
        "label": "North-West"
    },
    {
        "iso": "ZA",
        "value": "WC",
        "label": "Western Cape"
    }
];
